// const translations = {
//   categories: {
//     "Lighting Control": {
//       english: "Lighting Control",
//       dutch: "Verlichtingsbediening",
//       french: "Contrôle de l'éclairage",
//       german: "Lichtsteuerung",
//       italian: "Controllo illuminazione",
//       spanish: "Control de iluminación"
//     },

//     "Lighting preset colors change": {
//       english: "Lighting preset colors change",
//       dutch: "Vooraf ingestelde lichtkleuren wijzigen",
//       french: "Modifier les couleurs prédéfinies de l'éclairage",
//       german: "Voreingestellte Lichtfarben ändern",
//       italian: "Modifica colori predefiniti dell'illuminazione",
//       spanish: "Cambiar colores predefinidos de la iluminación"
//     },

//     "Switch/Plug/Socket/Outlet control": {
//       english: "Switch/Plug/Socket/Outlet control",
//       dutch: "Schakelaar-/Stekker-/Stopcontactbediening",
//       french: "Contrôle des interrupteurs, prises et sockets",
//       german: "Schalter-/Stecker-/Steckdosensteuerung",
//       italian: "Controllo interruttori, spine e prese",
//       spanish: "Control de interruptores, enchufes y tomas"
//     },

//     "Thermostat Temperature control": {
//       english: "Thermostat Temperature control",
//       dutch: "Thermostaat temperatuurregeling",
//       french: "Contrôle de la température du thermostat",
//       german: "Thermostat-Temperatursteuerung",
//       italian: "Controllo della temperatura del termostato",
//       spanish: "Control de temperatura del termostato"
//     },

//     "Fan Control": {
//       english: "Fan Control",
//       dutch: "Ventilatorbediening",
//       french: "Contrôle du ventilateur",
//       german: "Lüftersteuerung",
//       italian: "Controllo della ventola",
//       spanish: "Control del ventilador"
//     },

//     "Air Purifier control": {
//       english: "Air Purifier control",
//       dutch: "Luchtreinigerbediening",
//       french: "Contrôle du purificateur d'air",
//       german: "Luftreinigersteuerung",
//       italian: "Controllo del purificatore d'aria",
//       spanish: "Control del purificador de aire"
//     },

//     "Blinds, Curtain, shades control": {
//       english: "Blinds, Curtain, shades control",
//       dutch: "Bediening van jaloezieën, gordijnen en zonwering",
//       french: "Contrôle des stores, rideaux et volets",
//       german: "Steuerung von Jalousien, Vorhängen und Rollos",
//       italian: "Controllo di tende, persiane e oscuranti",
//       spanish: "Control de persianas, cortinas y estores"
//     }
//   },

//   voiceControls: {
//         "Turn on <light>": {
//       english: "Turn on <light>",
//       dutch: "Zet <light> aan",
//       french: "Allumer <light>",
//       german: "Schalte <light> ein",
//       italian: "Accendi <light>",
//       spanish: "Enciende <light>"
//     },

//     "Turn off <light>": {
//       english: "Turn off <light>",
//       dutch: "Zet <light> uit",
//       french: "Éteindre <light>",
//       german: "Schalte <light> aus",
//       italian: "Spegni <light>",
//       spanish: "Apaga <light>"
//     },

//     "Switch on <light>": {
//       english: "Switch on <light>",
//       dutch: "Schakel <light> in",
//       french: "Allume <light>",
//       german: "Schalte <light> ein",
//       italian: "Accendi <light>",
//       spanish: "Enciende <light>"
//     },

//     "Switch off <light>": {
//       english: "Switch off <light>",
//       dutch: "Schakel <light> uit",
//       french: "Éteins <light>",
//       german: "Schalte <light> aus",
//       italian: "Spegni <light>",
//       spanish: "Apaga <light>"
//     },

//     "Power on <light>": {
//       english: "Power on <light>",
//       dutch: "Schakel <light> in",
//       french: "Mettre <light> sous tension",
//       german: "Schalte <light> ein",
//       italian: "Accendi <light>",
//       spanish: "Enciende <light>"
//     },

//     "Power off <light>": {
//       english: "Power off <light>",
//       dutch: "Schakel <light> uit",
//       french: "Éteindre <light>",
//       german: "Schalte <light> aus",
//       italian: "Spegni <light>",
//       spanish: "Apaga <light>"
//     },

//     "Brighter": {
//       english: "Brighter",
//       dutch: "Helderder",
//       french: "Plus lumineux",
//       german: "Heller",
//       italian: "Più luminoso",
//       spanish: "Más brillante"
//     },

//     "Brightness": {
//       english: "Brightness",
//       dutch: "Helderheid",
//       french: "Luminosité",
//       german: "Helligkeit",
//       italian: "Luminosità",
//       spanish: "Brillo"
//     },

//     "Dimmer": {
//       english: "Dimmer",
//       dutch: "Dimmen",
//       french: "Réduire la luminosité",
//       german: "Dimmen",
//       italian: "Abbassa luminosità",
//       spanish: "Reducir brillo"
//     },

//     "Warmer": {
//       english: "Warmer",
//       dutch: "Warmer",
//       french: "Plus chaud",
//       german: "Wärmer",
//       italian: "Più caldo",
//       spanish: "Más cálido"
//     },

//     "Cooler": {
//       english: "Cooler",
//       dutch: "Koeler",
//       french: "Plus froid",
//       german: "Kühler",
//       italian: "Più freddo",
//       spanish: "Más frío"
//     },

//     "Cool": {
//       english: "Cool",
//       dutch: "Koel",
//       french: "Froid",
//       german: "Kühl",
//       italian: "Freddo",
//       spanish: "Frío"
//     },

//     "Softer": {
//       english: "Softer",
//       dutch: "Zachter",
//       french: "Plus doux",
//       german: "Weicher",
//       italian: "Più morbido",
//       spanish: "Más suave"
//     },

//     "Soft": {
//       english: "Soft",
//       dutch: "Zacht",
//       french: "Doux",
//       german: "Weich",
//       italian: "Morbido",
//       spanish: "Suave"
//     },

//     "Set the <light name> to warm white": {
//       english: "Set the <light name> to warm white",
//       dutch: "Zet <light name> op warm wit",
//       french: "Régler <light name> sur blanc chaud",
//       german: "Stelle <light name> auf Warmweiß",
//       italian: "Imposta <light name> su bianco caldo",
//       spanish: "Configura <light name> en blanco cálido"
//     },

//     "Change the <light name> to amber": {
//       english: "Change the <light name> to amber",
//       dutch: "Verander <light name> naar amber",
//       french: "Changer <light name> en ambre",
//       german: "Stelle <light name> auf Bernstein",
//       italian: "Imposta <light name> su ambra",
//       spanish: "Cambiar <light name> a ámbar"
//     },

//     "Make the <light name> to blue": {
//       english: "Make the <light name> to blue",
//       dutch: "Maak <light name> blauw",
//       french: "Mettre <light name> en bleu",
//       german: "Stelle <light name> auf Blau",
//       italian: "Imposta <light name> su blu",
//       spanish: "Pon <light name> en azul"
//     },

//     "Set the <light name> to white": {
//       english: "Set the <light name> to white",
//       dutch: "Zet <light name> op wit",
//       french: "Régler <light name> sur blanc",
//       german: "Stelle <light name> auf Weiß",
//       italian: "Imposta <light name> su bianco",
//       spanish: "Configura <light name> en blanco"
//     },

//     "Change the <light name> to cool white": {
//       english: "Change the <light name> to cool white",
//       dutch: "Verander <light name> naar koel wit",
//       french: "Changer <light name> en blanc froid",
//       german: "Stelle <light name> auf Kaltweiß",
//       italian: "Imposta <light name> su bianco freddo",
//       spanish: "Cambia <light name> a blanco frío"
//     },

//     "Make the <light name> to daylight": {
//       english: "Make the <light name> to daylight",
//       dutch: "Zet <light name> op daglicht",
//       french: "Mettre <light name> en lumière du jour",
//       german: "Stelle <light name> auf Tageslicht",
//       italian: "Imposta <light name> su luce diurna",
//       spanish: "Pon <light name> en luz de día"
//     },    "Set the <light name> to red": {
//       english: "Set the <light name> to red",
//       dutch: "Zet <light name> op rood",
//       french: "Régler <light name> sur rouge",
//       german: "Stelle <light name> auf Rot",
//       italian: "Imposta <light name> su rosso",
//       spanish: "Configura <light name> en rojo"
//     },

//     "Change the <light name> to blue": {
//       english: "Change the <light name> to blue",
//       dutch: "Verander <light name> naar blauw",
//       french: "Changer <light name> en bleu",
//       german: "Ändere <light name> zu Blau",
//       italian: "Cambia <light name> in blu",
//       spanish: "Cambia <light name> a azul"
//     },

//     "Switch the <light name> to cool white": {
//       english: "Switch the <light name> to cool white",
//       dutch: "Schakel <light name> naar koel wit",
//       french: "Passe <light name> en blanc froid",
//       german: "Schalte <light name> auf Kaltweiß",
//       italian: "Imposta <light name> su bianco freddo",
//       spanish: "Cambia <light name> a blanco frío"
//     },

//     "Turn on switch": {
//       english: "Turn on switch",
//       dutch: "Zet schakelaar aan",
//       french: "Allumer l'interrupteur",
//       german: "Schalter einschalten",
//       italian: "Accendi l'interruttore",
//       spanish: "Enciende el interruptor"
//     },

//     "Turn off switch": {
//       english: "Turn off switch",
//       dutch: "Zet schakelaar uit",
//       french: "Éteindre l'interrupteur",
//       german: "Schalter ausschalten",
//       italian: "Spegni l'interruttore",
//       spanish: "Apaga el interruptor"
//     },

//     "Turn on plug": {
//       english: "Turn on plug",
//       dutch: "Zet stekker aan",
//       french: "Allumer la prise",
//       german: "Stecker einschalten",
//       italian: "Accendi la presa",
//       spanish: "Enciende el enchufe"
//     },

//     "Turn off plug": {
//       english: "Turn off plug",
//       dutch: "Zet stekker uit",
//       french: "Éteindre la prise",
//       german: "Stecker ausschalten",
//       italian: "Spegni la presa",
//       spanish: "Apaga el enchufe"
//     },

//     "Turn on socket": {
//       english: "Turn on socket",
//       dutch: "Zet stopcontact aan",
//       french: "Allumer la prise",
//       german: "Steckdose einschalten",
//       italian: "Accendi la presa",
//       spanish: "Enciende la toma"
//     },

//     "Turn off socket": {
//       english: "Turn off socket",
//       dutch: "Zet stopcontact uit",
//       french: "Éteindre la prise",
//       german: "Steckdose ausschalten",
//       italian: "Spegni la presa",
//       spanish: "Apaga la toma"
//     },

//     "Turn on <outlet>": {
//       english: "Turn on <outlet>",
//       dutch: "Zet <outlet> aan",
//       french: "Allumer <outlet>",
//       german: "Schalte <outlet> ein",
//       italian: "Accendi <outlet>",
//       spanish: "Enciende <outlet>"
//     },

//     "Turn off <outlet>": {
//       english: "Turn off <outlet>",
//       dutch: "Zet <outlet> uit",
//       french: "Éteindre <outlet>",
//       german: "Schalte <outlet> aus",
//       italian: "Spegni <outlet>",
//       spanish: "Apaga <outlet>"
//     },

//     "Activate <outlet>": {
//       english: "Activate <outlet>",
//       dutch: "Activeer <outlet>",
//       french: "Activer <outlet>",
//       german: "Aktiviere <outlet>",
//       italian: "Attiva <outlet>",
//       spanish: "Activa <outlet>"
//     },

//     "Switch on <outlet>": {
//       english: "Switch on <outlet>",
//       dutch: "Schakel <outlet> in",
//       french: "Allumer <outlet>",
//       german: "Schalte <outlet> ein",
//       italian: "Accendi <outlet>",
//       spanish: "Enciende <outlet>"
//     },

//     "Power off socket": {
//       english: "Power off socket",
//       dutch: "Schakel stopcontact uit",
//       french: "Couper l'alimentation de la prise",
//       german: "Steckdose ausschalten",
//       italian: "Disattiva la presa",
//       spanish: "Desconecta la toma"
//     },

//     "Switch off socket": {
//       english: "Switch off socket",
//       dutch: "Schakel stopcontact uit",
//       french: "Éteindre la prise",
//       german: "Steckdose ausschalten",
//       italian: "Spegni la presa",
//       spanish: "Apaga la toma"
//     },

//     "Increase temperature": {
//       english: "Increase temperature",
//       dutch: "Verhoog temperatuur",
//       french: "Augmenter la température",
//       german: "Temperatur erhöhen",
//       italian: "Aumenta temperatura",
//       spanish: "Aumentar temperatura"
//     },

//     "Decrease temperature": {
//       english: "Decrease temperature",
//       dutch: "Verlaag temperatuur",
//       french: "Diminuer la température",
//       german: "Temperatur senken",
//       italian: "Diminuire temperatura",
//       spanish: "Disminuir temperatura"
//     },

//     "Set to heat mode": {
//       english: "Set to heat mode",
//       dutch: "Zet op verwarmingsmodus",
//       french: "Régler en mode chauffage",
//       german: "Auf Heizmodus stellen",
//       italian: "Imposta modalità riscaldamento",
//       spanish: "Configurar modo calefacción"
//     },

//     "Turn up": {
//       english: "Turn up",
//       dutch: "Zet hoger",
//       french: "Augmenter",
//       german: "Höher stellen",
//       italian: "Alza",
//       spanish: "Subir"
//     },

//     "Turn down": {
//       english: "Turn down",
//       dutch: "Zet lager",
//       french: "Baisser",
//       german: "Runter stellen",
//       italian: "Abbassa",
//       spanish: "Bajar"
//     },

//     "Raise": {
//       english: "Raise",
//       dutch: "Verhoog",
//       french: "Augmenter",
//       german: "Erhöhen",
//       italian: "Alza",
//       spanish: "Subir"
//     },

//     "Switch to cool mode": {
//       english: "Switch to cool mode",
//       dutch: "Schakel naar koelmodus",
//       french: "Passer en mode froid",
//       german: "Auf Kühlmodus wechseln",
//       italian: "Passa alla modalità fredda",
//       spanish: "Cambiar a modo frío"
//     },

//     "Switch to warm mode": {
//       english: "Switch to warm mode",
//       dutch: "Schakel naar warme modus",
//       french: "Passer en mode chaud",
//       german: "Auf Heizmodus wechseln",
//       italian: "Passa alla modalità calda",
//       spanish: "Cambiar a modo cálido"
//     },

//     "Reduce": {
//       english: "Reduce",
//       dutch: "Verlaag",
//       french: "Réduire",
//       german: "Reduzieren",
//       italian: "Riduci",
//       spanish: "Reducir"
//     },

//     "Set": {
//       english: "Set",
//       dutch: "Instellen",
//       french: "Régler",
//       german: "Einstellen",
//       italian: "Imposta",
//       spanish: "Configurar"
//     },

//     "What is the current room temperature": {
//       english: "What is the current room temperature",
//       dutch: "Wat is de huidige kamertemperatuur",
//       french: "Quelle est la température actuelle de la pièce",
//       german: "Wie hoch ist die aktuelle Raumtemperatur",
//       italian: "Qual è la temperatura ambiente attuale",
//       spanish: "¿Cuál es la temperatura actual de la habitación?"
//     },

//     "What is the ambient temperature": {
//       english: "What is the ambient temperature",
//       dutch: "Wat is de omgevingstemperatuur",
//       french: "Quelle est la température ambiante",
//       german: "Wie hoch ist die Umgebungstemperatur",
//       italian: "Qual è la temperatura ambiente",
//       spanish: "¿Cuál es la temperatura ambiente?"
//     },
//         "Set to low speed": {
//       english: "Set to low speed",
//       dutch: "Zet op lage snelheid",
//       french: "Régler sur vitesse faible",
//       german: "Auf niedrige Geschwindigkeit stellen",
//       italian: "Imposta su velocità bassa",
//       spanish: "Configurar velocidad baja"
//     },

//     "Set to medium speed": {
//       english: "Set to medium speed",
//       dutch: "Zet op gemiddelde snelheid",
//       french: "Régler sur vitesse moyenne",
//       german: "Auf mittlere Geschwindigkeit stellen",
//       italian: "Imposta su velocità media",
//       spanish: "Configurar velocidad media"
//     },

//     "Set to high speed": {
//       english: "Set to high speed",
//       dutch: "Zet op hoge snelheid",
//       french: "Régler sur vitesse élevée",
//       german: "Auf hohe Geschwindigkeit stellen",
//       italian: "Imposta su velocità alta",
//       spanish: "Configurar velocidad alta"
//     },

//     "Set to auto": {
//       english: "Set to auto",
//       dutch: "Zet op automatisch",
//       french: "Régler sur automatique",
//       german: "Auf Automatik stellen",
//       italian: "Imposta su automatico",
//       spanish: "Configurar en automático"
//     },

//     "Set to off": {
//       english: "Set to off",
//       dutch: "Zet uit",
//       french: "Mettre hors tension",
//       german: "Ausschalten",
//       italian: "Imposta su spento",
//       spanish: "Apagar"
//     },

//     "Turn on fan": {
//       english: "Turn on fan",
//       dutch: "Zet ventilator aan",
//       french: "Allumer le ventilateur",
//       german: "Ventilator einschalten",
//       italian: "Accendi il ventilatore",
//       spanish: "Enciende el ventilador"
//     },

//     "Turn off fan": {
//       english: "Turn off fan",
//       dutch: "Zet ventilator uit",
//       french: "Éteindre le ventilateur",
//       german: "Ventilator ausschalten",
//       italian: "Spegni il ventilatore",
//       spanish: "Apaga el ventilador"
//     },

//     "Switch on": {
//       english: "Switch on",
//       dutch: "Schakel in",
//       french: "Allumer",
//       german: "Einschalten",
//       italian: "Accendi",
//       spanish: "Encender"
//     },

//     "Power on": {
//       english: "Power on",
//       dutch: "Inschakelen",
//       french: "Mettre sous tension",
//       german: "Einschalten",
//       italian: "Accendere",
//       spanish: "Encender"
//     },

//     "Increase": {
//       english: "Increase",
//       dutch: "Verhoog",
//       french: "Augmenter",
//       german: "Erhöhen",
//       italian: "Aumenta",
//       spanish: "Aumentar"
//     },

//     "Put": {
//       english: "Put",
//       dutch: "Zet",
//       french: "Mettre",
//       german: "Stellen",
//       italian: "Metti",
//       spanish: "Pon"
//     },

//     "Keep": {
//       english: "Keep",
//       dutch: "Houd",
//       french: "Maintenir",
//       german: "Beibehalten",
//       italian: "Mantieni",
//       spanish: "Mantener"
//     },

//     "Lower": {
//       english: "Lower",
//       dutch: "Verlaag",
//       french: "Abaisser",
//       german: "Senken",
//       italian: "Abbassa",
//       spanish: "Bajar"
//     },

//     "Turn on": {
//       english: "Turn on",
//       dutch: "Zet aan",
//       french: "Allumer",
//       german: "Einschalten",
//       italian: "Accendi",
//       spanish: "Encender"
//     },

//     "Turn off": {
//       english: "Turn off",
//       dutch: "Zet uit",
//       french: "Éteindre",
//       german: "Ausschalten",
//       italian: "Spegni",
//       spanish: "Apagar"
//     },

//     "Decrease": {
//       english: "Decrease",
//       dutch: "Verlaag",
//       french: "Diminuer",
//       german: "Verringern",
//       italian: "Riduci",
//       spanish: "Reducir"
//     },

//     "Blinds": {
//       english: "Blinds",
//       dutch: "Jaloezieën",
//       french: "Stores",
//       german: "Jalousien",
//       italian: "Tende",
//       spanish: "Persianas"
//     },

//     "Curtain": {
//       english: "Curtain",
//       dutch: "Gordijn",
//       french: "Rideau",
//       german: "Vorhang",
//       italian: "Tenda",
//       spanish: "Cortina"
//     },

//     "Roller Shades": {
//       english: "Roller Shades",
//       dutch: "Rolgordijnen",
//       french: "Stores enrouleurs",
//       german: "Rollos",
//       italian: "Tende a rullo",
//       spanish: "Estores enrollables"
//     },

//     "Open blinds": {
//       english: "Open blinds",
//       dutch: "Open jaloezieën",
//       french: "Ouvrir les stores",
//       german: "Jalousien öffnen",
//       italian: "Apri le tende",
//       spanish: "Abrir persianas"
//     },

//     "Close blinds": {
//       english: "Close blinds",
//       dutch: "Sluit jaloezieën",
//       french: "Fermer les stores",
//       german: "Jalousien schließen",
//       italian: "Chiudi le tende",
//       spanish: "Cerrar persianas"
//     },

//     "Stop blinds": {
//       english: "Stop blinds",
//       dutch: "Stop jaloezieën",
//       french: "Arrêter les stores",
//       german: "Jalousien stoppen",
//       italian: "Ferma le tende",
//       spanish: "Detener persianas"
//     },

//     "Lower shades": {
//       english: "Lower shades",
//       dutch: "Laat zonwering zakken",
//       french: "Abaisser les stores",
//       german: "Rollos herunterlassen",
//       italian: "Abbassa le tende",
//       spanish: "Bajar persianas"
//     },

//     "Raise curtain": {
//       english: "Raise curtain",
//       dutch: "Hef gordijn op",
//       french: "Lever le rideau",
//       german: "Vorhang hochziehen",
//       italian: "Alza la tenda",
//       spanish: "Subir cortina"
//     },

//     "Roll down": {
//       english: "Roll down",
//       dutch: "Rol omlaag",
//       french: "Dérouler",
//       german: "Herunterrollen",
//       italian: "Abbassa",
//       spanish: "Bajar"
//     },

//     "Move": {
//       english: "Move",
//       dutch: "Verplaats",
//       french: "Déplacer",
//       german: "Bewegen",
//       italian: "Sposta",
//       spanish: "Mover"
//     },

//     "Lift": {
//       english: "Lift",
//       dutch: "Optillen",
//       french: "Lever",
//       german: "Anheben",
//       italian: "Solleva",
//       spanish: "Levantar"
//     }
//   }
// };

// const iotControlData = {
//   "Lighting Control": {
//     "Turn on <light>": {
//       english: [
//         "Turn on Attic ceiling light",
//         "Turn on counter light",
//         "Turn on island light"
//       ],
//       dutch: [
//         "Zet de plafondlamp op zolder aan",
//         "Zet het aanrechtlicht aan",
//         "Zet het eilandlicht aan"
//       ],
//       french: [
//         "Allumer la lumière du plafond du grenier",
//         "Mets en marche la lumière du comptoir",
//         "Mets en marche la lumière de l'îlot"
//       ],
//       german: [
//         "Schalten Sie die Dachbodenbeleuchtung ein.",
//         "Schalte das Arbeitsplattenlicht ein",
//         "Schalte das Insellicht ein"
//       ],
//       italian: [
//         "Accendere la luce del soffitto della soffitta",
//         "Accendi la luce del bancone",
//         "Accendi la luce dell'isola"
//       ],
//       spanish: [
//         "Encender la luz del techo del ático",
//         "Enciende la luz del mostrador",
//         "Enciende la luz de la isla"
//       ]
//     },

//     "Turn off <light>": {
//       english: [
//         "Turn off basement ceiling light",
//         "Turn off staircase light",
//         "Turn off cabinet light"
//       ],
//       dutch: [
//         "Zet de plafondlamp in de kelder uit",
//         "Zet het traplicht uit",
//         "Zet het kastlicht uit"
//       ],
//       french: [
//         "Éteindre la lumière du plafond du sous-sol",
//         "Éteins la lumière de l'escalier",
//         "Éteins la lumière de l'armoire"
//       ],
//       german: [
//         "Schalten Sie die Kellerbeleuchtung aus.",
//         "Schalte das Treppenlicht aus",
//         "Schalte das Schranklicht aus"
//       ],
//       italian: [
//         "Spegnere la luce del soffitto della cantina",
//         "Spegni la luce della scala.",
//         "Spegni la luce dell'armadio"
//       ],
//       spanish: [
//         "Apagar la luz del techo del sótano",
//         "Apaga la luz de la escalera",
//         "Apaga la luz del armario"
//       ]
//     },

//     "Switch on <light>": {
//       english: [
//         "Switch on the ceiling light 2 in bedroom 1"
//       ],
//       dutch: [
//         "Schakel plafondlamp 2 in slaapkamer 1 in."
//       ],
//       french: [
//         "Allumez le Plafondlamp 2 dans la chambre 1."
//       ],
//       german: [
//         "Schalten Sie die Deckenleuchte 2 in Schlafzimmer 1 ein."
//       ],
//       italian: [
//         "Accendi la plafoniera 2 nella camera da letto 1."
//       ],
//       spanish: [
//         "Enciende Lámpara del techo 2 en el dormitorio 1."
//       ]
//     },

//     "Switch off <light>": {
//       english: [
//         "Switch off the wall light 3 in bedroom 4"
//       ],
//       dutch: [
//         "Schakel wandlamp 3 in slaapkamer 4 uit."
//       ],
//       french: [
//         "Éteignez l 'Wandlamp 3 dans la chambre 4."
//       ],
//       german: [
//         "Schalten Sie die Wandleuchte 3 in Schlafzimmer 4 aus."
//       ],
//       italian: [
//         "Spegni la lampada da parete 3 nella camera da letto 4."
//       ],
//       spanish: [
//         "Apaga la lámpara de pared 3 del dormitorio 4."
//       ]
//     },

//     "Power on <light>": {
//       english: [
//         "Power on the pendant light in garage"
//       ],
//       dutch: [
//         "Schakel de hanglamp in de garage in."
//       ],
//       french: [
//         "Allumez la Hanglamp du garage."
//       ],
//       german: [
//         "Schalten Sie die Pendelleuchte in der Garage ein."
//       ],
//       italian: [
//         "Accendi la lampada a sospensione in garage."
//       ],
//       spanish: [
//         "Enciende la lámpara colgante del Jardín."
//       ]
//     },

//     "Power off <light>": {
//       english: [
//         "Power off the Reading lamp 2 in kidroom 3"
//       ],
//       dutch: [
//         "Schakel leeslamp 2 in kinderkamer 3 uit."
//       ],
//       french: [
//         "Éteignez la lampe de lecture 2 dans la chambre d'enfant 3."
//       ],
//       german: [
//         "Schalte die Leseleuchte 2 im Kinderzimmer 3 aus."
//       ],
//       italian: [
//         "Spegni la lampada da lettura 2 nella cameretta 3."
//       ],
//       spanish: [
//         "Apaga la lámpara de lectura 2 en la Dormitorio infantil 3."
//       ]
//     },

//     "Brighter": {
//       english: [
//         "change lounge standing light to brighter"
//       ],
//       dutch: [
//         "Versterk de staande lamp in de woonkamer"
//       ],
//       french: [
//         "Augmenter la luminosité du lampadaire du salon."
//       ],
//       german: [
//         "Stehleuchte im Wohnzimmer heller stellen."
//       ],
//       italian: [
//         "Rendere la luce del soggiorno più luminosa"
//       ],
//       spanish: [
//         "Cambiar la luz de pie del salón a más brillante."
//       ]
//     },

//     "Brightness": {
//       english: [
//         "Increase the brightness of the garage corner light 3"
//       ],
//       dutch: [
//         "Verhoog de helderheid van hoeklamp 3 in de garage."
//       ],
//       french: [
//         "Augmentez la luminosité Plafondlamp d'angle n° 3 du garage."
//       ],
//       german: [
//         "Erhöhen Sie die Helligkeit der Garageneckenleuchte 3."
//       ],
//       italian: [
//         "Aumenta la luminosità della luce nell'angolo 3 del garage."
//       ],
//       spanish: [
//         "Aumenta el brillo de la luz de la esquina del garaje 3."
//       ]
//     },

//     "Dimmer": {
//       english: [
//         "change dining room corner light to dimmer",
//         "Make Cabinet light 2 dimmer"
//       ],
//       dutch: [
//         "Dim de hoeklamp in de eetkamer",
//         "Zet kastverlichting 2 op een lagere lichtsterkte."
//       ],
//       french: [
//         "Diminuer l'intensité de l'applique d'angle de la salle à manger.",
//         "Réduire l'intensité de l'éclairage du Plafondlamp 2"
//       ],
//       german: [
//         "Eckleuchte im Esszimmer dimmen.",
//         "Schrankleuchte 2 dimmen"
//       ],
//       italian: [
//         "Rendere la luce d'angolo della sala da pranzo più fioca",
//         "Regola la luminosità della Luce per mobiletto 2"
//       ],
//       spanish: [
//         "Cambiar la luz de la esquina del comedor a más tenue.",
//         "Reduce la intensidad de Lámpara de armario 2."
//       ]
//     },

//     "Warmer": {
//       english: [
//         "Make family room wall light warmer"
//       ],
//       dutch: [
//         "Maak de wandlamp in de woonkamer warmer"
//       ],
//       french: [
//         "Rendre l'applique murale du salon plus chaude"
//       ],
//       german: [
//         "Die Wandleuchte im Wohnzimmer wärmer gestalten"
//       ],
//       italian: [
//         "Rendere la luce da parete del soggiorno più calda"
//       ],
//       spanish: [
//         "Haz que la luz de pared de la sala de estar sea más cálida."
//       ]
//     },

//     "Cooler": {
//       english: [
//         "Make study room reading light cooler"
//       ],
//       dutch: [
//         "Maak de leeslamp in de studeerkamer koeler"
//       ],
//       french: [
//         "Rendre la lampe de lecture du bureau plus froide"
//       ],
//       german: [
//         "Die Leselampe im Arbeitszimmer kühler gestalten"
//       ],
//       italian: [
//         "Rendere la luce da lettura dello studio più fredda"
//       ],
//       spanish: [
//         "Haz que la luz de lectura de la sala de estudio sea más fría"
//       ]
//     },

//     "Cool": {
//       english: [
//         "Set light to cool mode"
//       ],
//       dutch: [
//         "Zet Verlichting op de koele stand"
//       ],
//       french: [
//         "Réglez la lumière sur le mode froid."
//       ],
//       german: [
//         "Lampe auf den Kühlmodus einstellen"
//       ],
//       italian: [
//         "Imposta la luce sulla modalità fredda."
//       ],
//       spanish: [
//         "Cambia la luz al modo frío."
//       ]
//     },

//     "Softer": {
//       english: [
//         "Make home office table lamp softer"
//       ],
//       dutch: [
//         "Maak de tafellamp in het thuiskantoor zachter"
//       ],
//       french: [
//         "Rendre la lampe de bureau du bureau à domicile sur une intensité plus faible"
//       ],
//       german: [
//         "Die Tischlampe im Homeoffice sanfter einstellen"
//       ],
//       italian: [
//         "Rendi la lampada da tavolo dell'ufficio più soffusa"
//       ],
//       spanish: [
//         "Haz que la lámpara de mesa del despacho sea más tenue"
//       ]
//     },

//     "Soft": {
//       english: [
//         "Change table lamp to a soft setting"
//       ],
//       dutch: [
//         "Zet de tafellamp op een zachte stand."
//       ],
//       french: [
//         "Réglez la Verlichting sur un éclairage doux."
//       ],
//       german: [
//         "Stellen Sie die Tischlampe auf eine sanfte Einstellung um."
//       ],
//       italian: [
//         "Cambiare la luce da tavolo in un'impostazione più morbida"
//       ],
//       spanish: [
//         "Reduce la intensidad de la Lámpara del armario 2."
//       ]
//     },
//       },

//   "Lighting preset colors change": {
//     "Set the <light name> to warm white": {
//       english: [
//         "Set family room wall light to warm white"
//       ],
//       dutch: [
//         "Zet de wandlamp in de familiekamer op warm wit"
//       ],
//       french: [
//         "Règle l'applique murale de la salle familiale sur blanc chaud"
//       ],
//       german: [
//         "Stelle die Wandleuchte im Familienzimmer auf warmweiß"
//       ],
//       italian: [
//         "Imposta la lampada da parete della sala familiare su bianco caldo"
//       ],
//       spanish: [
//         "Configura la lámpara de pared de la sala familiar en blanco cálido"
//       ]
//     },

//     "Change the <light name> to amber": {
//       english: [
//         "Change main bedroom ceiling fan light to amber"
//       ],
//       dutch: [
//         "Zet de plafondlamplicht in de hoofdslaapkamer op amber"
//       ],
//       french: [
//         "Change la lumière du ventilateur de plafond de la chambre principale en ambre"
//       ],
//       german: [
//         "Stelle das Deckenventilator-Licht im Hauptschlafzimmer auf Bernstein"
//       ],
//       italian: [
//         "Cambia la luce del ventilatore a soffitto della camera principale in ambra"
//       ],
//       spanish: [
//         "Cambia la luz del ventilador de techo del dormitorio principal a ámbar"
//       ]
//     },

//     "Make the <light name> to blue": {
//       english: [
//         "Make kid room 1 ceiling light to blue"
//       ],
//       dutch: [
//         "Zet de plafondlicht in kinderkamer 1 op blauw"
//       ],
//       french: [
//         "Mets le plafonnier de la chambre d'enfant 1 en bleu"
//       ],
//       german: [
//         "Stelle die Deckenlampe im Kinderzimmer 1 auf Blau"
//       ],
//       italian: [
//         "Metti la lampada a soffitto della cameretta 1 su blu"
//       ],
//       spanish: [
//         "Pon la lámpara de techo del cuarto infantil 1 en azul"
//       ]
//     },

//     "Set the <light name> to white": {
//       english: [
//         "Set storage room light to white",
//         "Set kid room 2 bedside lamp to orange",
//         "Set kid room 3 sconce to pink",
//         "Set lounge counter light to red"
//       ],
//       dutch: [
//         "Zet de lamp in de berging op wit",
//         "Zet het nachtlampje in kinderkamer 2 op oranje",
//         "Zet de wandlamp in kinderkamer 3 op roze",
//         "Zet de counterlamp in de lounge op rood"
//       ],
//       french: [
//         "Règle la lampe du débarras sur blanc",
//         "Règle la lampe de chevet de la chambre d'enfant 2 sur orange",
//         "Règle l'applique murale de la chambre d'enfant 3 sur rose",
//         "Règle la lumière du comptoir du salon sur rouge"
//       ],
//       german: [
//         "Stelle die Lampe im Abstellraum auf Weiß",
//         "Stelle die Nachttischlampe im Kinderzimmer 2 auf Orange",
//         "Stelle die Wandleuchte im Kinderzimmer 3 auf Rosa",
//         "Stelle die Thekenleuchte im Wohnzimmer auf Rot."
//       ],
//       italian: [
//         "Cambia la lampada da terra della camera da letto 1 in bianco freddo",
//         "Imposta la lampada da comodino della cameretta 2 su arancione",
//         "Imposta l'applique della cameretta 3 su rosa",
//         "Imposta la luce del bancone del soggiorno su rosso"
//       ],
//       spanish: [
//         "Cambia la lámpara de pie del dormitorio 1 a blanco frío",
//         "Configura la lámpara de noche del cuarto infantil 2 en naranja",
//         "Configura el aplique del cuarto infantil 3 en rosa",
//         "Configura la luz del mostrador del salón en rojo"
//       ]
//     },

//     "Change the <light name> to cool white": {
//       english: [
//         "Change bedroom 1 floor lamp to cool white",
//         "Change the hall chandelier to yellow",
//         "Change the hallway wall light to teal"
//       ],
//       dutch: [
//         "Zet de vloerlamp in slaapkamer 1 op koel wit",
//         "Zet de kroonluchter in de hal op geel",
//         "Zet de wandlamp in de gang op blauwgroen"
//       ],
//       french: [
//         "Change la lampe sur pied de la chambre 1 en blanc froid",
//         "Change le lustre du hall en jaune",
//         "Change l'applique murale du couloir en turquoise"
//       ],
//       german: [
//         "Stelle die Stehlampe im Schlafzimmer 1 auf Kaltweiß",
//         "Stelle den Kronleuchter im Flur auf Gelb",
//         "Stelle die Wandleuchte im Flur auf Türkis"
//       ],
//       italian: [
//         "Metti la lampada a sospensione della camera da letto 2 su luce diurna",
//         "Imposta il lampadario dell'ingresso su giallo",
//         "Imposta l'applique del corridoio su turchese"
//       ],
//       spanish: [
//         "Pon la lámpara colgante del dormitorio 2 en luz de día",
//         "Configura la lámpara de araña del pasillo en amarillo",
//         "Configura la lámpara de pared del pasillo en turquesa"
//       ]
//     },

//     "Make the <light name> to daylight": {
//       english: [
//         "Make bedroom 2 pendant light to daylight",
//         "Make garden light to green",
//         "Make the hallway ceiling light to cyan",
//         "Make the main bedroom headboard light to magenta"
//       ],
//       dutch: [
//         "Zet de hanglamp in slaapkamer 2 op daglicht",
//         "Zet de tuinlamp op groen",
//         "Zet de plafondlamp in de gang op cyaan",
//         "Zet de hoofdbordlamp in de hoofdslaapkamer op magenta"
//       ],
//       french: [
//         "Mets la suspension de la chambre 2 en lumière du jour",
//         "Mets la lampe de jardin en vert",
//         "Mets le plafonnier du couloir en cyan",
//         "Mets la lampe de tête de lit de la chambre principale en magenta"
//       ],
//       german: [
//         "Stelle die Hängeleuchte im Schlafzimmer 2 auf Tageslichtweiß",
//         "Stelle die Gartenlampe auf Grün",
//         "Stelle die Deckenleuchte im Flur auf Cyan",
//         "Stelle die Kopfteil-Leuchte im Hauptschlafzimmer auf Magenta"
//       ],
//       italian: [
//         "Imposta la lampada da comodino della cameretta 2 su arancione",
//         "Imposta la lampada da giardino su verde",
//         "Imposta la plafoniera del corridoio su ciano",
//         "Imposta la luce della testata del letto nella camera matrimoniale su magenta"
//       ],
//       spanish: [
//         "Configura la lámpara de noche del cuarto infantil 2 en naranja",
//         "Configura la lámpara del jardín en verde",
//         "Configura la lámpara de techo del pasillo en cian",
//         "Configura la luz del cabecero en el dormitorio principal en magenta"
//       ]
//     },

//     "Set the <light name> to red": {
//       english: [
//         "Set the Hallway desk lamp to red"
//       ],
//       dutch: [
//         "Zet de bureaulamp in de gang op rood."
//       ],
//       french: [
//         "Réglez la lampe de bureau du couloir sur la couleur rouge."
//       ],
//       german: [
//         "Stellen Sie die Schreibtischlampe im Flur auf Rot ein."
//       ],
//       italian: [
//         "Imposta la Luce da scrivania del corridoio sul rosso."
//       ],
//       spanish: [
//         "Pon la lámpara de escritorio del pasillo en rojo."
//       ]
//     },

//     "Change the <light name> to blue": {
//       english: [
//         "Change the storage room 6 floor lamp 6 to blue"
//       ],
//       dutch: [
//         "Verander de Berg vloerlamp 6 naar blauw."
//       ],
//       french: [
//         "Changez la Vloerlamp de la chambre d'enfant en rouge."
//       ],
//       german: [
//         "Ändere die Abstellraum 6 im Stehleuchte 6 auf Blau."
//       ],
//       italian: [
//         "Cambia il colore della Luce da terra 6 nel ripostiglio 6 in blu."
//       ],
//       spanish: [
//         "Cambia la lámpara de pie del cuarto de almacenamiento 6 a color azul."
//       ]
//     },

//     "Switch the <light name> to cool white": {
//       english: [
//         "Switch the chandelier 1 to cool white"
//       ],
//       dutch: [
//         "Zet Kandelaar 1 op koel wit."
//       ],
//       french: [
//         "Réglez le Kandelaar 1 sur blanc froid."
//       ],
//       german: [
//         "Schalten Sie den Kerzenständer 1 auf Kaltweiß."
//       ],
//       italian: [
//         "Imposta il lampadario 1 su bianco freddo."
//       ],
//       spanish: [
//         "Cambia la lámpara de araña 1 a blanco frío."
//       ]
//     }
//   },  "Switch/Plug/Socket/Outlet control": {
//     "Turn on switch": {
//       english: [
//         "Turn on accent light switch"
//       ],
//       dutch: [
//         "Zet de accentlichtschakelaar aan"
//       ],
//       french: [
//         "Mets en marche l'interrupteur de la lumière d'accentuation"
//       ],
//       german: [
//         "Schalte den Akzentlichtschalter ein"
//       ],
//       italian: [
//         "Accendi l'interruttore della luce d'accento"
//       ],
//       spanish: [
//         "Enciende el interruptor de la luz de acento"
//       ]
//     },

//     "Turn off switch": {
//       english: [
//         "Turn off desk lamp switch"
//       ],
//       dutch: [
//         "Zet de bureaulampschakelaar uit"
//       ],
//       french: [
//         "Éteins l'interrupteur de la lampe de bureau"
//       ],
//       german: [
//         "Schalte den Schalter der Schreibtischlampe aus"
//       ],
//       italian: [
//         "Spegni l'interruttore della lampada da scrivania"
//       ],
//       spanish: [
//         "Apaga el interruptor de la lámpara de escritorio"
//       ]
//     },

//     "Turn on plug": {
//       english: [
//         "Turn on kettle plug"
//       ],
//       dutch: [
//         "Zet de waterkokerstekker aan"
//       ],
//       french: [
//         "Mets en marche la prise de la bouilloire"
//       ],
//       german: [
//         "Schalte den Wasserkocherstecker ein"
//       ],
//       italian: [
//         "Accendi la presa del bollitore"
//       ],
//       spanish: [
//         "Enciende el enchufe del hervidor"
//       ]
//     },

//     "Turn off plug": {
//       english: [
//         "Turn off water boiler plug"
//       ],
//       dutch: [
//         "Zet de waterkokerschakelaar uit"
//       ],
//       french: [
//         "Éteins la prise du chauffe-eau"
//       ],
//       german: [
//         "Schalte den Wasserkocherstecker aus"
//       ],
//       italian: [
//         "Spegni la presa del boiler"
//       ],
//       spanish: [
//         "Apaga el enchufe del calentador de agua"
//       ]
//     },

//     "Turn on socket": {
//       english: [
//         "Turn on TV socket"
//       ],
//       dutch: [
//         "Zet het tv-stopcontact aan"
//       ],
//       french: [
//         "Mets en marche la prise TV"
//       ],
//       german: [
//         "Schalte die TV-Steckdose ein"
//       ],
//       italian: [
//         "Accendi la presa della TV"
//       ],
//       spanish: [
//         "Enciende el enchufe de la TV"
//       ]
//     },

//     "Turn off socket": {
//       english: [
//         "Turn off TV socket"
//       ],
//       dutch: [
//         "Zet het tv-stopcontact uit"
//       ],
//       french: [
//         "Éteins la prise TV"
//       ],
//       german: [
//         "Schalte die TV-Steckdose aus"
//       ],
//       italian: [
//         "Spegni la presa della TV"
//       ],
//       spanish: [
//         "Apaga el enchufe de la TV"
//       ]
//     },

//     "Turn on <outlet>": {
//       english: [
//         "Turn on charging socket",
//         "Turn on coffee maker socket"
//       ],
//       dutch: [
//         "Zet het oplaadstopcontact aan",
//         "Zet het stopcontact van het koffiezetapparaat aan"
//       ],
//       french: [
//         "Mets en marche la prise de charge",
//         "Mets en marche la prise de la cafetière"
//       ],
//       german: [
//         "Schalte die Ladesteckdose ein",
//         "Schalte die Steckdose der Kaffeemaschine ein"
//       ],
//       italian: [
//         "Accendi la presa di ricarica",
//         "Accendi la presa della macchina del caffè"
//       ],
//       spanish: [
//         "Enciende el enchufe de carga",
//         "Enciende la toma de la cafetera"
//       ]
//     },

//     "Turn off <outlet>": {
//       english: [
//         "Turn off computer outlet",
//         "Turn off cooker outlet"
//       ],
//       dutch: [
//         "Zet het computerstopcontact uit",
//         "Zet het stopcontact van het fornuis uit"
//       ],
//       french: [
//         "Éteins la prise de l'ordinateur",
//         "Éteins la prise de la cuisinière"
//       ],
//       german: [
//         "Schalte die Computersteckdose aus",
//         "Schalte die Herdsteckdose aus"
//       ],
//       italian: [
//         "Spegni la presa del computer",
//         "Spegni la presa del fornello"
//       ],
//       spanish: [
//         "Apaga el enchufe del ordenador",
//         "Apaga la toma del horno"
//       ]
//     },

//     "Activate <outlet>": {
//       english: [
//         "Activate Coffee maker outlet 4 in livingroom"
//       ],
//       dutch: [
//         "Activeer stopcontact 4 voor het koffiezetapparaat in de woonkamer."
//       ],
//       french: [
//         "Activer la prise n° 4 de la cafetière dans le salon"
//       ],
//       german: [
//         "Steckdose 4 für die Kaffeemaschine im Wohnzimmer aktivieren"
//       ],
//       italian: [
//         "Attiva la presa n. 4 per la macchina del caffè nel soggiorno."
//       ],
//       spanish: [
//         "Activar la toma de corriente 4 de la cafetera en la sala de estar."
//       ]
//     },

//     "Switch on <outlet>": {
//       english: [
//         "Switch on Cooker outlet 2"
//       ],
//       dutch: [
//         "Schakel Fornuisstopcontact 2 in."
//       ],
//       french: [
//         "Allumer la prise de la cuisinière 2"
//       ],
//       german: [
//         "Herdanschlussdose 2 einschalten"
//       ],
//       italian: [
//         "Accensione Presa fornello 2"
//       ],
//       spanish: [
//         "Encienda la toma de corriente de la cocina n.º 2."
//       ]
//     },

//     "Power off socket": {
//       english: [
//         "Power off Socket in Attic"
//       ],
//       dutch: [
//         "Stopcontact op zolder uitschakelen"
//       ],
//       french: [
//         "Éteindre la prise de l'espace de vie"
//       ],
//       german: [
//         "Steckdose auf dem Dachboden stromlos schalten"
//       ],
//       italian: [
//         "Disattivare la presa in soffitta"
//       ],
//       spanish: [
//         "Desconectar el enchufe del ático"
//       ]
//     },

//     "Switch off socket": {
//       english: [
//         "switch off outlet 3"
//       ],
//       dutch: [
//         "Schakel stopcontact 3 uit."
//       ],
//       french: [
//         "Éteindre la prise de charge TV n° 3"
//       ],
//       german: [
//         "Steckdose 3 ausschalten"
//       ],
//       italian: [
//         "Spegni la presa 3"
//       ],
//       spanish: [
//         "Apagar la toma de corriente 3"
//       ]
//     }
//   },  "Thermostat Temperature control": {
//     "Increase temperature": {
//       english: [
//         "Increase temperature on hall thermostat"
//       ],
//       dutch: [
//         "Verhoog de temperatuur op de thermostaat in de hal"
//       ],
//       french: [
//         "Augmenter la température du thermostat du couloir"
//       ],
//       german: [
//         "Temperatur am Flurthermostat erhöhen"
//       ],
//       italian: [
//         "Aumentare la temperatura del termostato del corridoio"
//       ],
//       spanish: [
//         "Subir la temperatura del termostato del pasillo"
//       ]
//     },

//     "Decrease temperature": {
//       english: [
//         "Decrease temperature on hallway thermostat"
//       ],
//       dutch: [
//         "Verlaag de temperatuur op de thermostaat in de hal"
//       ],
//       french: [
//         "Diminuer la température du thermostat du couloir"
//       ],
//       german: [
//         "Temperatur am Flurthermostat senken"
//       ],
//       italian: [
//         "Diminuire la temperatura del termostato del corridoio"
//       ],
//       spanish: [
//         "Bajar la temperatura del termostato del pasillo"
//       ]
//     },

//     "Set to cool mode": {
//       english: [
//         "set dining room thermostat to cool mode"
//       ],
//       dutch: [
//         "Zet de thermostaat in de eetkamer op koelen"
//       ],
//       french: [
//         "Régler le thermostat de la salle à manger en mode refroidissement"
//       ],
//       german: [
//         "Thermostat im Esszimmer auf Kühlmodus stellen"
//       ],
//       italian: [
//         "Impostare il termostato della sala da pranzo in modalità raffreddamento"
//       ],
//       spanish: [
//         "Configurar el termostato del comedor en modo frío"
//       ]
//     },

//     "Set to heat mode": {
//       english: [
//         "set garage thermostat to heat mode"
//       ],
//       dutch: [
//         "Zet de thermostaat in de garage op verwarmen"
//       ],
//       french: [
//         "Régler le thermostat du garage en mode chauffage"
//       ],
//       german: [
//         "Thermostat in der Garage auf Heizmodus stellen"
//       ],
//       italian: [
//         "Impostare il termostato del garage in modalità riscaldamento"
//       ],
//       spanish: [
//         "Configurar el termostato del garaje en modo calor"
//       ]
//     },

//     "Turn up": {
//       english: [
//         "Turn up the bedroom 3 thermostat"
//       ],
//       dutch: [
//         "Zet de thermostaat van slaapkamer 3 hoger."
//       ],
//       french: [
//         "Augmentez le thermostat de la chambre d'amis."
//       ],
//       german: [
//         "Dreh das Thermostat im Schlafzimmer 3 höher."
//       ],
//       italian: [
//         "Alza il termostato della camera da letto 3."
//       ],
//       spanish: [
//         "Sube el termostato del dormitorio 3."
//       ]
//     },

//     "Turn down": {
//       english: [
//         "Turn down storage room thermostat temperature"
//       ],
//       dutch: [
//         "Verlaag de temperatuur van de thermostaat in de berging."
//       ],
//       french: [
//         "Baissez la température du thermostat du local de Débarras."
//       ],
//       german: [
//         "Temperatur am Thermostat des Abstellraum senken"
//       ],
//       italian: [
//         "Abbassa la temperatura del termostato del ripostiglio."
//       ],
//       spanish: [
//         "Baja la temperatura del termostato del trastero."
//       ]
//     },

//     "Raise": {
//       english: [
//         "Raise the thermostat temperature",
//         "Raise the kitchen thermostat to 26°C."
//       ],
//       dutch: [
//         "Zet de thermostaat hoger",
//         "Zet de thermostaat in de keuken hoger, op 26°C."
//       ],
//       french: [
//         "Augmentez la température du thermostat.",
//         "Montez le thermostat de la cuisine à 26 °C."
//       ],
//       german: [
//         "Erhöhen Sie die Temperatur am Thermostat.",
//         "Stellen Sie das Küchenthermostat auf 26 °C."
//       ],
//       italian: [
//         "Alza la temperatura del termostato.",
//         "Alza il termostato della cucina a 26°C."
//       ],
//       spanish: [
//         "Sube la temperatura del termostato.",
//         "Sube el termostato de la cocina a 26 °C."
//       ]
//     },

//     "Switch to cool mode": {
//       english: [
//         "Switch Laundryroom thermostat to cool mode"
//       ],
//       dutch: [
//         "Zet de thermostaat in de wasruimte op de koelstand."
//       ],
//       french: [
//         "Réglez le thermostat de la buanderie sur le mode refroidissement."
//       ],
//       german: [
//         "Thermostat im Waschküche auf Kühlmodus stellen"
//       ],
//       italian: [
//         "Imposta il termostato della lavanderia sulla modalità di raffreddamento."
//       ],
//       spanish: [
//         "Cambie el termostato del cuarto de lavado al modo de refrigeración."
//       ]
//     },

//     "Switch to warm mode": {
//       english: [
//         "Switch bathroom 2 thermostat to warm mode"
//       ],
//       dutch: [
//         "Zet de thermostaat van badkamer 2 op de verwarmingsstand."
//       ],
//       french: [
//         "Réglez le thermostat de la salle de bain n° 2 sur le mode chauffage."
//       ],
//       german: [
//         "Thermostat im Badezimmer 2 auf Heizmodus stellen"
//       ],
//       italian: [
//         "Imposta il termostato del secondo bagno sulla modalità riscaldamento."
//       ],
//       spanish: [
//         "Cambia el termostato del baño 2 al modo de calefacción."
//       ]
//     },

//     "Reduce": {
//       english: [
//         "Reduce the Bedroom eight thermostat temperature to 7°C"
//       ],
//       dutch: [
//         "Verlaag de temperatuur van de thermostaat in slaapkamer 8 naar 7 °C."
//       ],
//       french: [
//         "Réglez la température du thermostat de la chambre 8 sur 7 °C."
//       ],
//       german: [
//         "Senken Sie die Temperatur des Thermostats in Schlafzimmer 8 auf 7 °C."
//       ],
//       italian: [
//         "Imposta la temperatura del termostato della Camera da letto 8 a 7°C."
//       ],
//       spanish: [
//         "Reduce la temperatura del termostato del dormitorio 8 a 7 °C."
//       ]
//     },

//     "Set": {
//       english: [
//         "Set thermostat to warm in attic"
//       ],
//       dutch: [
//         "Stel de thermostaat in de zolder in op warm"
//       ],
//       french: [
//         "Régler le thermostat du grenier sur chaud"
//       ],
//       german: [
//         "Stelle das Thermostat im Dachboden auf warm"
//       ],
//       italian: [
//         "Imposta il termostato della soffitta su caldo"
//       ],
//       spanish: [
//         "Ajusta el termostato del ático a cálido"
//       ]
//     },

//     "What is the current room temperature": {
//       english: [
//         "What is the current room temperature"
//       ],
//       dutch: [
//         "Wat is de huidige kamertemperatuur?"
//       ],
//       french: [
//         "Quelle est la température actuelle de la pièce ?"
//       ],
//       german: [
//         "Wie hoch ist die aktuelle Raumtemperatur?"
//       ],
//       italian: [
//         "Qual è la temperatura ambiente attuale?"
//       ],
//       spanish: [
//         "¿Cuál es la temperatura actual de la habitación?"
//       ]
//     },

//     "What is the ambient temperature": {
//       english: [
//         "What is the ambient temperature"
//       ],
//       dutch: [
//         "Wat is de omgevingstemperatuur"
//       ],
//       french: [
//         "Quelle est la température ambiante"
//       ],
//       german: [
//         "Wie hoch ist die Umgebungstemperatur?"
//       ],
//       italian: [
//         "Qual è la temperatura ambiente?"
//       ],
//       spanish: [
//         "¿Cuál es la temperatura ambiente?"
//       ]
//     }
//   },  "Fan Control": {
//     "Set to low speed": {
//       english: [
//         "set home office desk fan to low speed"
//       ],
//       dutch: [
//         "Zet de bureauventilator in het thuiskantoor op lage snelheid"
//       ],
//       french: [
//         "Réglez le ventilateur de bureau du bureau à domicile sur vitesse lente"
//       ],
//       german: [
//         "Stelle den Schreibtischventilator im Homeoffice auf niedrige Geschwindigkeit"
//       ],
//       italian: [
//         "Imposta il ventilatore da scrivania dell'ufficio su velocità bassa"
//       ],
//       spanish: [
//         "Configura el ventilador de escritorio de la oficina en casa a velocidad baja"
//       ]
//     },

//     "Set to medium speed": {
//       english: [
//         "Set bedroom fan to medium speed"
//       ],
//       dutch: [
//         "Zet de ventilator in de slaapkamer op gemiddelde snelheid"
//       ],
//       french: [
//         "Réglez le ventilateur de la chambre sur vitesse moyenne"
//       ],
//       german: [
//         "Stelle den Ventilator im Schlafzimmer auf mittlere Geschwindigkeit"
//       ],
//       italian: [
//         "Imposta il ventilatore della camera da letto su velocità media"
//       ],
//       spanish: [
//         "Configura el ventilador del dormitorio a velocidad media"
//       ]
//     },

//     "Set to high speed": {
//       english: [
//         "Set living room ceiling fan to high speed"
//       ],
//       dutch: [
//         "Zet de plafondventilator in de woonkamer op hoge snelheid"
//       ],
//       french: [
//         "Réglez le ventilateur de plafond du salon sur vitesse élevée"
//       ],
//       german: [
//         "Stelle den Deckenventilator im Wohnzimmer auf hohe Geschwindigkeit"
//       ],
//       italian: [
//         "Imposta il ventilatore a soffitto del soggiorno su velocità alta"
//       ],
//       spanish: [
//         "Configura el ventilador de techo de la sala a velocidad alta"
//       ]
//     },

//     "Set to auto": {
//       english: [
//         "Set office fan to auto mode"
//       ],
//       dutch: [
//         "Zet de kantoorventilator op automatische modus"
//       ],
//       french: [
//         "Réglez le ventilateur du bureau en mode automatique"
//       ],
//       german: [
//         "Stelle den Büroventilator auf Automatikmodus"
//       ],
//       italian: [
//         "Imposta il ventilatore dell'ufficio in modalità automatica"
//       ],
//       spanish: [
//         "Configura el ventilador de la oficina en modo automático"
//       ]
//     },

//     "Set to off": {
//       english: [
//         "Set kitchen fan to off"
//       ],
//       dutch: [
//         "Zet de keukenventilator uit"
//       ],
//       french: [
//         "Éteignez le ventilateur de la cuisine"
//       ],
//       german: [
//         "Schalte den Küchenventilator aus"
//       ],
//       italian: [
//         "Spegni il ventilatore della cucina"
//       ],
//       spanish: [
//         "Apaga el ventilador de la cocina"
//       ]
//     },

//     "Turn on fan": {
//       english: [
//         "Turn on dining room fan"
//       ],
//       dutch: [
//         "Zet de ventilator in de eetkamer aan"
//       ],
//       french: [
//         "Allumez le ventilateur de la salle à manger"
//       ],
//       german: [
//         "Schalte den Ventilator im Esszimmer ein"
//       ],
//       italian: [
//         "Accendi il ventilatore della sala da pranzo"
//       ],
//       spanish: [
//         "Enciende el ventilador del comedor"
//       ]
//     },

//     "Turn off fan": {
//       english: [
//         "Turn off garage fan"
//       ],
//       dutch: [
//         "Zet de garageventilator uit"
//       ],
//       french: [
//         "Éteignez le ventilateur du garage"
//       ],
//       german: [
//         "Schalte den Garagenventilator aus"
//       ],
//       italian: [
//         "Spegni il ventilatore del garage"
//       ],
//       spanish: [
//         "Apaga el ventilador del garaje"
//       ]
//     },

//     "Switch on": {
//       english: [
//         "Switch on fan in bedroom 2"
//       ],
//       dutch: [
//         "Schakel de ventilator in slaapkamer 2 in"
//       ],
//       french: [
//         "Allumez le ventilateur de la chambre 2"
//       ],
//       german: [
//         "Schalte den Ventilator in Schlafzimmer 2 ein"
//       ],
//       italian: [
//         "Accendi il ventilatore della camera da letto 2"
//       ],
//       spanish: [
//         "Enciende el ventilador del dormitorio 2"
//       ]
//     },

//     "Power on": {
//       english: [
//         "Power on office ceiling fan"
//       ],
//       dutch: [
//         "Schakel de plafondventilator op kantoor in"
//       ],
//       french: [
//         "Mettez sous tension le ventilateur de plafond du bureau"
//       ],
//       german: [
//         "Schalte den Büro-Deckenventilator ein"
//       ],
//       italian: [
//         "Accendi il ventilatore a soffitto dell'ufficio"
//       ],
//       spanish: [
//         "Enciende el ventilador de techo de la oficina"
//       ]
//     },

//     "Increase": {
//       english: [
//         "Increase fan speed"
//       ],
//       dutch: [
//         "Verhoog de ventilatorsnelheid"
//       ],
//       french: [
//         "Augmenter la vitesse du ventilateur"
//       ],
//       german: [
//         "Erhöhe die Lüftergeschwindigkeit"
//       ],
//       italian: [
//         "Aumenta la velocità della ventola"
//       ],
//       spanish: [
//         "Aumenta la velocidad del ventilador"
//       ]
//     },

//     "Put": {
//       english: [
//         "Put the fan on low"
//       ],
//       dutch: [
//         "Zet de ventilator op laag"
//       ],
//       french: [
//         "Mettez le ventilateur sur faible"
//       ],
//       german: [
//         "Stelle den Ventilator auf niedrig"
//       ],
//       italian: [
//         "Metti la ventola su bassa"
//       ],
//       spanish: [
//         "Pon el ventilador en velocidad baja"
//       ]
//     },

//     "Keep": {
//       english: [
//         "Keep fan running"
//       ],
//       dutch: [
//         "Laat de ventilator draaien"
//       ],
//       french: [
//         "Laissez le ventilateur en marche"
//       ],
//       german: [
//         "Lass den Ventilator weiterlaufen"
//       ],
//       italian: [
//         "Lascia la ventola accesa"
//       ],
//       spanish: [
//         "Mantén el ventilador funcionando"
//       ]
//     },

//     "Lower": {
//       english: [
//         "Lower fan speed"
//       ],
//       dutch: [
//         "Verlaag de ventilatorsnelheid"
//       ],
//       french: [
//         "Réduire la vitesse du ventilateur"
//       ],
//       german: [
//         "Verringere die Lüftergeschwindigkeit"
//       ],
//       italian: [
//         "Riduci la velocità della ventola"
//       ],
//       spanish: [
//         "Reduce la velocidad del ventilador"
//       ]
//     }
//   },  "Air Purifier control": {
//     "Turn on": {
//       english: [
//         "Turn on bedroom air purifier"
//       ],
//       dutch: [
//         "Zet de luchtreiniger in de slaapkamer aan"
//       ],
//       french: [
//         "Allumez le purificateur d'air de la chambre"
//       ],
//       german: [
//         "Schalte den Luftreiniger im Schlafzimmer ein"
//       ],
//       italian: [
//         "Accendi il purificatore d'aria della camera da letto"
//       ],
//       spanish: [
//         "Enciende el purificador de aire del dormitorio"
//       ]
//     },

//     "Turn off": {
//       english: [
//         "Turn off bedroom air purifier"
//       ],
//       dutch: [
//         "Zet de luchtreiniger in de slaapkamer uit"
//       ],
//       french: [
//         "Éteignez le purificateur d'air de la chambre"
//       ],
//       german: [
//         "Schalte den Luftreiniger im Schlafzimmer aus"
//       ],
//       italian: [
//         "Spegni il purificatore d'aria della camera da letto"
//       ],
//       spanish: [
//         "Apaga el purificador de aire del dormitorio"
//       ]
//     },

//     "Increase": {
//       english: [
//         "Increase air purifier speed"
//       ],
//       dutch: [
//         "Verhoog de snelheid van de luchtreiniger"
//       ],
//       french: [
//         "Augmentez la vitesse du purificateur d'air"
//       ],
//       german: [
//         "Erhöhe die Geschwindigkeit des Luftreinigers"
//       ],
//       italian: [
//         "Aumenta la velocità del purificatore d'aria"
//       ],
//       spanish: [
//         "Aumenta la velocidad del purificador de aire"
//       ]
//     },

//     "Decrease": {
//       english: [
//         "Decrease air purifier speed"
//       ],
//       dutch: [
//         "Verlaag de snelheid van de luchtreiniger"
//       ],
//       french: [
//         "Réduisez la vitesse du purificateur d'air"
//       ],
//       german: [
//         "Verringere die Geschwindigkeit des Luftreinigers"
//       ],
//       italian: [
//         "Riduci la velocità del purificatore d'aria"
//       ],
//       spanish: [
//         "Reduce la velocidad del purificador de aire"
//       ]
//     },

//     "Set to auto": {
//       english: [
//         "Set air purifier to auto mode"
//       ],
//       dutch: [
//         "Zet de luchtreiniger op automatische modus"
//       ],
//       french: [
//         "Réglez le purificateur d'air en mode automatique"
//       ],
//       german: [
//         "Stelle den Luftreiniger auf Automatikmodus"
//       ],
//       italian: [
//         "Imposta il purificatore d'aria in modalità automatica"
//       ],
//       spanish: [
//         "Configura el purificador de aire en modo automático"
//       ]
//     }
//   },

//   "Blinds, Curtain, shades control": {
//     "Open blinds": {
//       english: [
//         "Open living room blinds"
//       ],
//       dutch: [
//         "Open de jaloezieën in de woonkamer"
//       ],
//       french: [
//         "Ouvrir les stores du salon"
//       ],
//       german: [
//         "Öffne die Jalousien im Wohnzimmer"
//       ],
//       italian: [
//         "Apri le tende del soggiorno"
//       ],
//       spanish: [
//         "Abre las persianas del salón"
//       ]
//     },

//     "Close blinds": {
//       english: [
//         "Close bedroom blinds"
//       ],
//       dutch: [
//         "Sluit de jaloezieën in de slaapkamer"
//       ],
//       french: [
//         "Fermer les stores de la chambre"
//       ],
//       german: [
//         "Schließe die Jalousien im Schlafzimmer"
//       ],
//       italian: [
//         "Chiudi le tende della camera da letto"
//       ],
//       spanish: [
//         "Cierra las persianas del dormitorio"
//       ]
//     },

//     "Stop blinds": {
//       english: [
//         "Stop the blinds"
//       ],
//       dutch: [
//         "Stop de jaloezieën"
//       ],
//       french: [
//         "Arrêter les stores"
//       ],
//       german: [
//         "Stoppe die Jalousien"
//       ],
//       italian: [
//         "Ferma le tende"
//       ],
//       spanish: [
//         "Detén las persianas"
//       ]
//     },

//     "Lower shades": {
//       english: [
//         "Lower kitchen shades"
//       ],
//       dutch: [
//         "Laat de zonwering in de keuken zakken"
//       ],
//       french: [
//         "Abaissez les stores de la cuisine"
//       ],
//       german: [
//         "Senke die Rollos in der Küche"
//       ],
//       italian: [
//         "Abbassa le tende della cucina"
//       ],
//       spanish: [
//         "Baja los estores de la cocina"
//       ]
//     },

//     "Raise curtain": {
//       english: [
//         "Raise bedroom curtain"
//       ],
//       dutch: [
//         "Open het gordijn in de slaapkamer"
//       ],
//       french: [
//         "Lever le rideau de la chambre"
//       ],
//       german: [
//         "Ziehe den Vorhang im Schlafzimmer hoch"
//       ],
//       italian: [
//         "Alza la tenda della camera da letto"
//       ],
//       spanish: [
//         "Sube la cortina del dormitorio"
//       ]
//     },

//     "Roll down": {
//       english: [
//         "Roll down the shades"
//       ],
//       dutch: [
//         "Rol de zonwering naar beneden"
//       ],
//       french: [
//         "Déroulez les stores"
//       ],
//       german: [
//         "Fahre die Rollos herunter"
//       ],
//       italian: [
//         "Abbassa le tende a rullo"
//       ],
//       spanish: [
//         "Baja los estores"
//       ]
//     },

//     "Move": {
//       english: [
//         "Move the curtain halfway"
//       ],
//       dutch: [
//         "Beweeg het gordijn halverwege"
//       ],
//       french: [
//         "Déplacez le rideau à mi-hauteur"
//       ],
//       german: [
//         "Bewege den Vorhang zur Hälfte"
//       ],
//       italian: [
//         "Sposta la tenda a metà"
//       ],
//       spanish: [
//         "Mueve la cortina hasta la mitad"
//       ]
//     },

//     "Lift": {
//       english: [
//         "Lift the blinds"
//       ],
//       dutch: [
//         "Til de jaloezieën op"
//       ],
//       french: [
//         "Relevez les stores"
//       ],
//       german: [
//         "Hebe die Jalousien an"
//       ],
//       italian: [
//         "Solleva le tende"
//       ],
//       spanish: [
//         "Levanta las persianas"
//       ]
//     }
//   }
// };

// export {
//   iotControlData,
//   translations
// };


//new string updated 19-7-26
const translations = {
  categories: {
    "Lighting Control": {
      english: "Lighting Control",
      dutch: "Verlichtingsbediening",
      french: "Contrôle de l'éclairage",
      german: "Lichtsteuerung",
      italian: "Controllo illuminazione",
      spanish: "Control de iluminación"
    },

    "Lighting preset colors change": {
      english: "Lighting preset colors change",
      dutch: "Vooraf ingestelde lichtkleuren wijzigen",
      french: "Modifier les couleurs prédéfinies de l'éclairage",
      german: "Voreingestellte Lichtfarben ändern",
      italian: "Modifica colori predefiniti dell'illuminazione",
      spanish: "Cambiar colores predefinidos de la iluminación"
    },

    "Switch/Plug/Socket/Outlet control": {
      english: "Switch/Plug/Socket/Outlet control",
      dutch: "Schakelaar-/Stekker-/Stopcontactbediening",
      french: "Contrôle des interrupteurs, prises et sockets",
      german: "Schalter-/Stecker-/Steckdosensteuerung",
      italian: "Controllo interruttori, spine e prese",
      spanish: "Control de interruptores, enchufes y tomas"
    },

    "Thermostat Temperature control": {
      english: "Thermostat Temperature control",
      dutch: "Thermostaat temperatuurregeling",
      french: "Contrôle de la température du thermostat",
      german: "Thermostat-Temperatursteuerung",
      italian: "Controllo della temperatura del termostato",
      spanish: "Control de temperatura del termostato"
    },

    "Fan Control": {
      english: "Fan Control",
      dutch: "Ventilatorbediening",
      french: "Contrôle du ventilateur",
      german: "Lüftersteuerung",
      italian: "Controllo della ventola",
      spanish: "Control del ventilador"
    },

    "Air Purifier control": {
      english: "Air Purifier control",
      dutch: "Luchtreinigerbediening",
      french: "Contrôle du purificateur d'air",
      german: "Luftreinigersteuerung",
      italian: "Controllo del purificatore d'aria",
      spanish: "Control del purificador de aire"
    },

    "Blinds, Curtain, shades control": {
      english: "Blinds, Curtain, shades control",
      dutch: "Bediening van jaloezieën, gordijnen en zonwering",
      french: "Contrôle des stores, rideaux et volets",
      german: "Steuerung von Jalousien, Vorhängen und Rollos",
      italian: "Controllo di tende, persiane e oscuranti",
      spanish: "Control de persianas, cortinas y estores"
    }
  },

  voiceControls: {
        "Turn on <light>": {
      english: "Turn on <light>",
      dutch: "Zet <light> aan",
      french: "Allumer <light>",
      german: "Schalte <light> ein",
      italian: "Accendi <light>",
      spanish: "Enciende <light>"
    },

    "Turn off <light>": {
      english: "Turn off <light>",
      dutch: "Zet <light> uit",
      french: "Éteindre <light>",
      german: "Schalte <light> aus",
      italian: "Spegni <light>",
      spanish: "Apaga <light>"
    },

    "Switch on <light>": {
      english: "Switch on <light>",
      dutch: "Schakel <light> in",
      french: "Allume <light>",
      german: "Schalte <light> ein",
      italian: "Accendi <light>",
      spanish: "Enciende <light>"
    },

    "Switch off <light>": {
      english: "Switch off <light>",
      dutch: "Schakel <light> uit",
      french: "Éteins <light>",
      german: "Schalte <light> aus",
      italian: "Spegni <light>",
      spanish: "Apaga <light>"
    },

    "Power on <light>": {
      english: "Power on <light>",
      dutch: "Schakel <light> in",
      french: "Mettre <light> sous tension",
      german: "Schalte <light> ein",
      italian: "Accendi <light>",
      spanish: "Enciende <light>"
    },

    "Power off <light>": {
      english: "Power off <light>",
      dutch: "Schakel <light> uit",
      french: "Éteindre <light>",
      german: "Schalte <light> aus",
      italian: "Spegni <light>",
      spanish: "Apaga <light>"
    },

    "Brighter": {
      english: "Brighter",
      dutch: "Helderder",
      french: "Plus lumineux",
      german: "Heller",
      italian: "Più luminoso",
      spanish: "Más brillante"
    },

    "Brightness": {
      english: "Brightness",
      dutch: "Helderheid",
      french: "Luminosité",
      german: "Helligkeit",
      italian: "Luminosità",
      spanish: "Brillo"
    },

    "Dimmer": {
      english: "Dimmer",
      dutch: "Dimmen",
      french: "Réduire la luminosité",
      german: "Dimmen",
      italian: "Abbassa luminosità",
      spanish: "Reducir brillo"
    },

    "Warmer": {
      english: "Warmer",
      dutch: "Warmer",
      french: "Plus chaud",
      german: "Wärmer",
      italian: "Più caldo",
      spanish: "Más cálido"
    },

    "Cooler": {
      english: "Cooler",
      dutch: "Koeler",
      french: "Plus froid",
      german: "Kühler",
      italian: "Più freddo",
      spanish: "Más frío"
    },

    "Cool": {
      english: "Cool",
      dutch: "Koel",
      french: "Froid",
      german: "Kühl",
      italian: "Freddo",
      spanish: "Frío"
    },

    "Softer": {
      english: "Softer",
      dutch: "Zachter",
      french: "Plus doux",
      german: "Weicher",
      italian: "Più morbido",
      spanish: "Más suave"
    },

    "Soft": {
      english: "Soft",
      dutch: "Zacht",
      french: "Doux",
      german: "Weich",
      italian: "Morbido",
      spanish: "Suave"
    },

    "Set the <light name> to warm white": {
      english: "Set the <light name> to warm white",
      dutch: "Zet <light name> op warm wit",
      french: "Régler <light name> sur blanc chaud",
      german: "Stelle <light name> auf Warmweiß",
      italian: "Imposta <light name> su bianco caldo",
      spanish: "Configura <light name> en blanco cálido"
    },

    "Change the <light name> to amber": {
      english: "Change the <light name> to amber",
      dutch: "Verander <light name> naar amber",
      french: "Changer <light name> en ambre",
      german: "Stelle <light name> auf Bernstein",
      italian: "Imposta <light name> su ambra",
      spanish: "Cambiar <light name> a ámbar"
    },

    "Make the <light name> to blue": {
      english: "Make the <light name> to blue",
      dutch: "Maak <light name> blauw",
      french: "Mettre <light name> en bleu",
      german: "Stelle <light name> auf Blau",
      italian: "Imposta <light name> su blu",
      spanish: "Pon <light name> en azul"
    },

    "Set the <light name> to white": {
      english: "Set the <light name> to white",
      dutch: "Zet <light name> op wit",
      french: "Régler <light name> sur blanc",
      german: "Stelle <light name> auf Weiß",
      italian: "Imposta <light name> su bianco",
      spanish: "Configura <light name> en blanco"
    },

    "Change the <light name> to cool white": {
      english: "Change the <light name> to cool white",
      dutch: "Verander <light name> naar koel wit",
      french: "Changer <light name> en blanc froid",
      german: "Stelle <light name> auf Kaltweiß",
      italian: "Imposta <light name> su bianco freddo",
      spanish: "Cambia <light name> a blanco frío"
    },

    "Make the <light name> to daylight": {
      english: "Make the <light name> to daylight",
      dutch: "Zet <light name> op daglicht",
      french: "Mettre <light name> en lumière du jour",
      german: "Stelle <light name> auf Tageslicht",
      italian: "Imposta <light name> su luce diurna",
      spanish: "Pon <light name> en luz de día"
    },    "Set the <light name> to red": {
      english: "Set the <light name> to red",
      dutch: "Zet <light name> op rood",
      french: "Régler <light name> sur rouge",
      german: "Stelle <light name> auf Rot",
      italian: "Imposta <light name> su rosso",
      spanish: "Configura <light name> en rojo"
    },

    "Change the <light name> to blue": {
      english: "Change the <light name> to blue",
      dutch: "Verander <light name> naar blauw",
      french: "Changer <light name> en bleu",
      german: "Ändere <light name> zu Blau",
      italian: "Cambia <light name> in blu",
      spanish: "Cambia <light name> a azul"
    },

    "Switch the <light name> to cool white": {
      english: "Switch the <light name> to cool white",
      dutch: "Schakel <light name> naar koel wit",
      french: "Passe <light name> en blanc froid",
      german: "Schalte <light name> auf Kaltweiß",
      italian: "Imposta <light name> su bianco freddo",
      spanish: "Cambia <light name> a blanco frío"
    },

    "Turn on switch": {
      english: "Turn on switch",
      dutch: "Zet schakelaar aan",
      french: "Allumer l'interrupteur",
      german: "Schalter einschalten",
      italian: "Accendi l'interruttore",
      spanish: "Enciende el interruptor"
    },

    "Turn off switch": {
      english: "Turn off switch",
      dutch: "Zet schakelaar uit",
      french: "Éteindre l'interrupteur",
      german: "Schalter ausschalten",
      italian: "Spegni l'interruttore",
      spanish: "Apaga el interruptor"
    },

    "Turn on plug": {
      english: "Turn on plug",
      dutch: "Zet stekker aan",
      french: "Allumer la prise",
      german: "Stecker einschalten",
      italian: "Accendi la presa",
      spanish: "Enciende el enchufe"
    },

    "Turn off plug": {
      english: "Turn off plug",
      dutch: "Zet stekker uit",
      french: "Éteindre la prise",
      german: "Stecker ausschalten",
      italian: "Spegni la presa",
      spanish: "Apaga el enchufe"
    },

    "Turn on socket": {
      english: "Turn on socket",
      dutch: "Zet stopcontact aan",
      french: "Allumer la prise",
      german: "Steckdose einschalten",
      italian: "Accendi la presa",
      spanish: "Enciende la toma"
    },

    "Turn off socket": {
      english: "Turn off socket",
      dutch: "Zet stopcontact uit",
      french: "Éteindre la prise",
      german: "Steckdose ausschalten",
      italian: "Spegni la presa",
      spanish: "Apaga la toma"
    },

    "Turn on <outlet>": {
      english: "Turn on <outlet>",
      dutch: "Zet <outlet> aan",
      french: "Allumer <outlet>",
      german: "Schalte <outlet> ein",
      italian: "Accendi <outlet>",
      spanish: "Enciende <outlet>"
    },

    "Turn off <outlet>": {
      english: "Turn off <outlet>",
      dutch: "Zet <outlet> uit",
      french: "Éteindre <outlet>",
      german: "Schalte <outlet> aus",
      italian: "Spegni <outlet>",
      spanish: "Apaga <outlet>"
    },

    "Activate <outlet>": {
      english: "Activate <outlet>",
      dutch: "Activeer <outlet>",
      french: "Activer <outlet>",
      german: "Aktiviere <outlet>",
      italian: "Attiva <outlet>",
      spanish: "Activa <outlet>"
    },

    "Switch on <outlet>": {
      english: "Switch on <outlet>",
      dutch: "Schakel <outlet> in",
      french: "Allumer <outlet>",
      german: "Schalte <outlet> ein",
      italian: "Accendi <outlet>",
      spanish: "Enciende <outlet>"
    },

    "Power off socket": {
      english: "Power off socket",
      dutch: "Schakel stopcontact uit",
      french: "Couper l'alimentation de la prise",
      german: "Steckdose ausschalten",
      italian: "Disattiva la presa",
      spanish: "Desconecta la toma"
    },

    "Switch off socket": {
      english: "Switch off socket",
      dutch: "Schakel stopcontact uit",
      french: "Éteindre la prise",
      german: "Steckdose ausschalten",
      italian: "Spegni la presa",
      spanish: "Apaga la toma"
    },

    "Increase temperature": {
      english: "Increase temperature",
      dutch: "Verhoog temperatuur",
      french: "Augmenter la température",
      german: "Temperatur erhöhen",
      italian: "Aumenta temperatura",
      spanish: "Aumentar temperatura"
    },

    "Decrease temperature": {
      english: "Decrease temperature",
      dutch: "Verlaag temperatuur",
      french: "Diminuer la température",
      german: "Temperatur senken",
      italian: "Diminuire temperatura",
      spanish: "Disminuir temperatura"
    },

    "Set to heat mode": {
      english: "Set to heat mode",
      dutch: "Zet op verwarmingsmodus",
      french: "Régler en mode chauffage",
      german: "Auf Heizmodus stellen",
      italian: "Imposta modalità riscaldamento",
      spanish: "Configurar modo calefacción"
    },

    "Turn up": {
      english: "Turn up",
      dutch: "Zet hoger",
      french: "Augmenter",
      german: "Höher stellen",
      italian: "Alza",
      spanish: "Subir"
    },

    "Turn down": {
      english: "Turn down",
      dutch: "Zet lager",
      french: "Baisser",
      german: "Runter stellen",
      italian: "Abbassa",
      spanish: "Bajar"
    },

    "Raise": {
      english: "Raise",
      dutch: "Verhoog",
      french: "Augmenter",
      german: "Erhöhen",
      italian: "Alza",
      spanish: "Subir"
    },

    "Switch to cool mode": {
      english: "Switch to cool mode",
      dutch: "Schakel naar koelmodus",
      french: "Passer en mode froid",
      german: "Auf Kühlmodus wechseln",
      italian: "Passa alla modalità fredda",
      spanish: "Cambiar a modo frío"
    },

    "Switch to warm mode": {
      english: "Switch to warm mode",
      dutch: "Schakel naar warme modus",
      french: "Passer en mode chaud",
      german: "Auf Heizmodus wechseln",
      italian: "Passa alla modalità calda",
      spanish: "Cambiar a modo cálido"
    },

    "Reduce": {
      english: "Reduce",
      dutch: "Verlaag",
      french: "Réduire",
      german: "Reduzieren",
      italian: "Riduci",
      spanish: "Reducir"
    },

    "Set": {
      english: "Set",
      dutch: "Instellen",
      french: "Régler",
      german: "Einstellen",
      italian: "Imposta",
      spanish: "Configurar"
    },

    "What is the current room temperature": {
      english: "What is the current room temperature",
      dutch: "Wat is de huidige kamertemperatuur",
      french: "Quelle est la température actuelle de la pièce",
      german: "Wie hoch ist die aktuelle Raumtemperatur",
      italian: "Qual è la temperatura ambiente attuale",
      spanish: "¿Cuál es la temperatura actual de la habitación?"
    },

    "What is the ambient temperature": {
      english: "What is the ambient temperature",
      dutch: "Wat is de omgevingstemperatuur",
      french: "Quelle est la température ambiante",
      german: "Wie hoch ist die Umgebungstemperatur",
      italian: "Qual è la temperatura ambiente",
      spanish: "¿Cuál es la temperatura ambiente?"
    },
        "Set to low speed": {
      english: "Set to low speed",
      dutch: "Zet op lage snelheid",
      french: "Régler sur vitesse faible",
      german: "Auf niedrige Geschwindigkeit stellen",
      italian: "Imposta su velocità bassa",
      spanish: "Configurar velocidad baja"
    },

    "Set to medium speed": {
      english: "Set to medium speed",
      dutch: "Zet op gemiddelde snelheid",
      french: "Régler sur vitesse moyenne",
      german: "Auf mittlere Geschwindigkeit stellen",
      italian: "Imposta su velocità media",
      spanish: "Configurar velocidad media"
    },

    "Set to high speed": {
      english: "Set to high speed",
      dutch: "Zet op hoge snelheid",
      french: "Régler sur vitesse élevée",
      german: "Auf hohe Geschwindigkeit stellen",
      italian: "Imposta su velocità alta",
      spanish: "Configurar velocidad alta"
    },

    "Set to auto": {
      english: "Set to auto",
      dutch: "Zet op automatisch",
      french: "Régler sur automatique",
      german: "Auf Automatik stellen",
      italian: "Imposta su automatico",
      spanish: "Configurar en automático"
    },

    "Set to off": {
      english: "Set to off",
      dutch: "Zet uit",
      french: "Mettre hors tension",
      german: "Ausschalten",
      italian: "Imposta su spento",
      spanish: "Apagar"
    },

    "Turn on fan": {
      english: "Turn on fan",
      dutch: "Zet ventilator aan",
      french: "Allumer le ventilateur",
      german: "Ventilator einschalten",
      italian: "Accendi il ventilatore",
      spanish: "Enciende el ventilador"
    },

    "Turn off fan": {
      english: "Turn off fan",
      dutch: "Zet ventilator uit",
      french: "Éteindre le ventilateur",
      german: "Ventilator ausschalten",
      italian: "Spegni il ventilatore",
      spanish: "Apaga el ventilador"
    },

    "Switch on": {
      english: "Switch on",
      dutch: "Schakel in",
      french: "Allumer",
      german: "Einschalten",
      italian: "Accendi",
      spanish: "Encender"
    },

    "Power on": {
      english: "Power on",
      dutch: "Inschakelen",
      french: "Mettre sous tension",
      german: "Einschalten",
      italian: "Accendere",
      spanish: "Encender"
    },

    "Increase": {
      english: "Increase",
      dutch: "Verhoog",
      french: "Augmenter",
      german: "Erhöhen",
      italian: "Aumenta",
      spanish: "Aumentar"
    },

    "Put": {
      english: "Put",
      dutch: "Zet",
      french: "Mettre",
      german: "Stellen",
      italian: "Metti",
      spanish: "Pon"
    },

    "Keep": {
      english: "Keep",
      dutch: "Houd",
      french: "Maintenir",
      german: "Beibehalten",
      italian: "Mantieni",
      spanish: "Mantener"
    },

    "Lower": {
      english: "Lower",
      dutch: "Verlaag",
      french: "Abaisser",
      german: "Senken",
      italian: "Abbassa",
      spanish: "Bajar"
    },

    "Turn on": {
      english: "Turn on",
      dutch: "Zet aan",
      french: "Allumer",
      german: "Einschalten",
      italian: "Accendi",
      spanish: "Encender"
    },

    "Turn off": {
      english: "Turn off",
      dutch: "Zet uit",
      french: "Éteindre",
      german: "Ausschalten",
      italian: "Spegni",
      spanish: "Apagar"
    },

    "Decrease": {
      english: "Decrease",
      dutch: "Verlaag",
      french: "Diminuer",
      german: "Verringern",
      italian: "Riduci",
      spanish: "Reducir"
    },

    "Blinds": {
      english: "Blinds",
      dutch: "Jaloezieën",
      french: "Stores",
      german: "Jalousien",
      italian: "Tende",
      spanish: "Persianas"
    },

    "Curtain": {
      english: "Curtain",
      dutch: "Gordijn",
      french: "Rideau",
      german: "Vorhang",
      italian: "Tenda",
      spanish: "Cortina"
    },

    "Roller Shades": {
      english: "Roller Shades",
      dutch: "Rolgordijnen",
      french: "Stores enrouleurs",
      german: "Rollos",
      italian: "Tende a rullo",
      spanish: "Estores enrollables"
    },

    "Open blinds": {
      english: "Open blinds",
      dutch: "Open jaloezieën",
      french: "Ouvrir les stores",
      german: "Jalousien öffnen",
      italian: "Apri le tende",
      spanish: "Abrir persianas"
    },

    "Close blinds": {
      english: "Close blinds",
      dutch: "Sluit jaloezieën",
      french: "Fermer les stores",
      german: "Jalousien schließen",
      italian: "Chiudi le tende",
      spanish: "Cerrar persianas"
    },

    "Stop blinds": {
      english: "Stop blinds",
      dutch: "Stop jaloezieën",
      french: "Arrêter les stores",
      german: "Jalousien stoppen",
      italian: "Ferma le tende",
      spanish: "Detener persianas"
    },

    "Lower shades": {
      english: "Lower shades",
      dutch: "Laat zonwering zakken",
      french: "Abaisser les stores",
      german: "Rollos herunterlassen",
      italian: "Abbassa le tende",
      spanish: "Bajar persianas"
    },

    "Raise curtain": {
      english: "Raise curtain",
      dutch: "Hef gordijn op",
      french: "Lever le rideau",
      german: "Vorhang hochziehen",
      italian: "Alza la tenda",
      spanish: "Subir cortina"
    },

    "Roll down": {
      english: "Roll down",
      dutch: "Rol omlaag",
      french: "Dérouler",
      german: "Herunterrollen",
      italian: "Abbassa",
      spanish: "Bajar"
    },

    "Move": {
      english: "Move",
      dutch: "Verplaats",
      french: "Déplacer",
      german: "Bewegen",
      italian: "Sposta",
      spanish: "Mover"
    },

    "Lift": {
      english: "Lift",
      dutch: "Optillen",
      french: "Lever",
      german: "Anheben",
      italian: "Solleva",
      spanish: "Levantar"
    }
  }
};

const iotControlData = {
  "Lighting Control": {
    "Turn on": {
      "english": [
        "Turn on Attic ceiling light",
        "Turn on counter light",
        "Turn on island light"
      ],
      "dutch": [
        "Zet de plafondlamp op zolder aan",
        "Zet het aanrechtlicht aan",
        "Zet het eilandlicht aan"
      ],
      "french": [
        "Allumer la lumière du plafond du grenier",
        "Mets en marche la lumière du comptoir",
        "Mets en marche la lumière de l’îlot"
      ],
      "german": [
        "Schalte die Dachbodenbeleuchtung ein.",
        "Schalte das Arbeitsplattenlicht ein",
        "Schalte das Insellicht ein"
      ],
      "italian": [
        "Accendere la luce del soffitto della soffitta",
        "Accendi la luce del bancone",
        "Accendi la luce dell’isola"
      ],
      "spanish": [
        "Encender la luz del techo del ático",
        "Enciende la luz del mostrador",
        "Enciende la luz de la isla"
      ]
    },
    "Turn off": {
      "english": [
        "Turn off basement ceiling light",
        "Turn off staircase light",
        "Turn off cabinet light"
      ],
      "dutch": [
        "Zet de plafondlamp in de kelder uit",
        "Zet het traplicht uit",
        "Zet het kastlicht uit"
      ],
      "french": [
        "Éteindre la lumière du plafond du sous-sol",
        "Éteins la lumière de l’escalier",
        "Éteins la lumière de l’armoire"
      ],
      "german": [
        "Schalte die Kellerbeleuchtung aus.",
        "Schalte das Treppenlicht aus",
        "Schalte das Schranklicht aus"
      ],
      "italian": [
        "Spegnere la luce del soffitto della cantina",
        "Spegni la luce della scala.",
        "Spegni la luce dell’armadio"
      ],
      "spanish": [
        "Apagar la luz del techo del sótano",
        "Apaga la luz de la escalera",
        "Apaga la luz del armario"
      ]
    },
    "Switch on": {
      "english": [
        "Switch on the ceiling light 2 in bedroom 1"
      ],
      "dutch": [
        "Schakel plafondlamp 2 in slaapkamer 1 aan"
      ],
      "french": [
        "Allumez la lumière du plafond 2 dans la chambre 1"
      ],
      "german": [
        "Schalte die Deckenleuchte 2 in Schlafzimmer 1 ein."
      ],
      "italian": [
        "Accendi la plafoniera 2 nella camera da letto 1."
      ],
      "spanish": [
        "Enciende Lámpara 2 del techo del dormitorio 1."
      ]
    },
    "Power on": {
      "english": [
        "Power on the pendant light in garage"
      ],
      "dutch": [
        "Schakel de hanglamp in de garage aan."
      ],
      "french": [
        "Allumez la lampe suspendue du garage"
      ],
      "german": [
        "Schalte die Hängeleuchte in der Garage ein."
      ],
      "italian": [
        "Accendi la lampada a sospensione in garage."
      ],
      "spanish": [
        "Enciende la lámpara colgante del Jardín."
      ]
    },
    "Power off": {
      "english": [
        "Power off the Reading lamp 2 in kidroom 3"
      ],
      "dutch": [
        "Schakel leeslamp 2 in kinderkamer 3 uit."
      ],
      "french": [
        "Éteignez la lampe de lecture 2 dans la chambre d'enfant 3"
      ],
      "german": [
        "Schalte die Leseleuchte 2 in Kinderzimmer 3 aus."
      ],
      "italian": [
        "Spegni la lampada da lettura 2 nella cameretta 3."
      ],
      "spanish": [
        "Apaga la segunda  lámpara de lectura,  en el Dormitorio infantil 3."
      ]
    },
    "Switch off": {
      "english": [
        "Switch off the wall light 3 in bedroom 4"
      ],
      "dutch": [
        "Schakel wandlamp 3 in slaapkamer 4 uit."
      ],
      "french": [
        "Éteignez l'applique murale 3 dans la chambre 4"
      ],
      "german": [
        "Schalte die Wandleuchte 3 in Schlafzimmer 4 aus."
      ],
      "italian": [
        "Spegni la lampada da parete 3 nella camera da letto 4."
      ],
      "spanish": [
        "Apaga la lámpara 3 de pared , del dormitorio 4"
      ]
    },
    "Brighter": {
      "english": [
        "change lounge standing light to brighter"
      ],
      "dutch": [
        "Zet de stalamp in de woonkamer feller"
      ],
      "french": [
        "Augmenter la luminosité du lampadaire du salon"
      ],
      "german": [
        "Stehleuchte im Wohnzimmer heller stellen."
      ],
      "italian": [
        "Rendere la luce del soggiorno più luminosa"
      ],
      "spanish": [
        "Cambiar la luz de pie del salón a más brillante."
      ]
    },
    "Brightness": {
      "english": [
        "Increase the brightness of the garage corner light 3"
      ],
      "dutch": [
        "Zet de hoeklamp 3 in de garage feller"
      ],
      "french": [
        "Augmentez la luminosité de la lampe d'angle 3 du garage"
      ],
      "german": [
        "Erhöhe die Helligkeit der Garageneckenleuchte 3."
      ],
      "italian": [
        "Aumenta la luminosità della luce nell'angolo 3 del garage."
      ],
      "spanish": [
        "Aumenta el brillo de la luz 3 de esquina del garaje."
      ]
    },
    "Dimmer": {
      "english": [
        "change dining room corner light to dimmer",
        "Make Cabinet light 2 dimmer"
      ],
      "dutch": [
        "Dim de hoeklamp in de eetkamer",
        "Dim de kastverlichting 2"
      ],
      "french": [
        "Diminuer l'intensité de l'applique d'angle de la salle à manger",
        "Réduire l'intensité de l'éclairage d'armoire  2"
      ],
      "german": [
        "Eckleuchte im Esszimmer dimmen.",
        "Schrankleuchte 2 dimmen"
      ],
      "italian": [
        "Rendere la luce d'angolo della sala da pranzo più fioca",
        "Regola la luminosità della Luce per mobiletto 2"
      ],
      "spanish": [
        "Cambiar la luz de la esquina del comedor a más tenue.",
        "Reduce la intensidad de Lámpara de armario 2."
      ]
    },
    "Warmer": {
      "english": [
        "Make family room wall light warmer"
      ],
      "dutch": [
        "Maak de wandlamp in de woonkamer warmer"
      ],
      "french": [
        "Rendre l'applique murale de la salle familiale plus chaude"
      ],
      "german": [
        "Die Wandleuchte im Wohnzimmer wärmer gestalten"
      ],
      "italian": [
        "Rendere la luce da parete del soggiorno più calda"
      ],
      "spanish": [
        "Haz que la luz de pared de la sala de estar sea más cálida."
      ]
    },
    "Cooler": {
      "english": [
        "Make study room reading light cooler"
      ],
      "dutch": [
        "Maak de leeslamp in de studeerkamer koeler"
      ],
      "french": [
        "Rendre la lampe de lecture du bureau plus froide"
      ],
      "german": [
        "Die Leselampe im Arbeitszimmer kühler gestalten"
      ],
      "italian": [
        "Rendere la luce da lettura dello studio più fredda"
      ],
      "spanish": [
        "Haz que la luz de lectura de la sala de estudio sea más fría"
      ]
    },
    "Cool": {
      "english": [
        "Set light to cool mode"
      ],
      "dutch": [
        "Zet Verlichting op de koele stand"
      ],
      "french": [
        "Réglez la lumière sur le mode froid"
      ],
      "german": [
        "Lampe kühler einstellen"
      ],
      "italian": [
        "Imposta la luce sulla modalità fredda."
      ],
      "spanish": [
        "Cambia la luz al modo frío."
      ]
    },
    "Softer": {
      "english": [
        "Make home office table lamp softer"
      ],
      "dutch": [
        "Maak de tafellamp in het thuiskantoor zachter"
      ],
      "french": [
        "Rendre la lampe de bureau du bureau à domicile moins intense"
      ],
      "german": [
        "Die Tischlampe im Homeoffice sanfter einstellen"
      ],
      "italian": [
        "Rendi la lampada da tavolo dell’ufficio più soffusa"
      ],
      "spanish": [
        "ajusta la lámpara de mesa del despacho a más tenue"
      ]
    },
    "Soft": {
      "english": [
        "Change table lamp to a soft setting"
      ],
      "dutch": [
        "Zet de tafellamp op een zachte stand."
      ],
      "french": [
        "Réglez la lampe de bureau sur un éclairage doux"
      ],
      "german": [
        "Stellen Sie die Tischlampe auf eine sanfte Einstellung um."
      ],
      "italian": [
        "Cambiare la luce da tavolo in un'impostazione più morbida"
      ],
      "spanish": [
        "Reduce la intensidad de la Lámpara del armario 2."
      ]
    }
  },
  "Lighting  preset colors change": {
    "Set the   to warm white": {
      "english": [
        "Set family room wall light to warm white"
      ],
      "dutch": [
        "Zet de wandlamp in de familiekamer op warm wit"
      ],
      "french": [
        "Règle l’applique murale de la salle familiale sur blanc chaud"
      ],
      "german": [
        "Stelle die Wandleuchte im Familienzimmer auf warmweiß"
      ],
      "italian": [
        "Imposta la lampada da parete della sala familiare su bianco caldo"
      ],
      "spanish": [
        "Configura la lámpara de pared de la sala familiar a blanco cálido"
      ]
    },
    "Change the  to amber": {
      "english": [
        "Change main bedroom ceiling fan light to amber"
      ],
      "dutch": [
        "Zet het plafondventilatorlicht in de hoofdslaapkamer op amber"
      ],
      "french": [
        "Change la lumière du ventilateur de plafond de la chambre principale en ambre"
      ],
      "german": [
        "Stelle das Deckenventilator‑Licht im Hauptschlafzimmer auf Bernstein"
      ],
      "italian": [
        "Cambia la luce del ventilatore a soffitto della camera principale in ambra"
      ],
      "spanish": [
        "Cambia la luz del ventilador de techo del dormitorio principal a ámbar"
      ]
    },
    "Make the  to blue": {
      "english": [
        "Make kid room 1 ceiling light to blue"
      ],
      "dutch": [
        "Zet het plafondlicht in kinderkamer 1 op blauw"
      ],
      "french": [
        "Mets le plafonnier de la chambre d’enfant 1 en bleu"
      ],
      "german": [
        "Stelle die Deckenlampe im Kinderzimmer 1 auf Blau"
      ],
      "italian": [
        "Metti la lampada a soffitto della cameretta 1 su blu"
      ],
      "spanish": [
        "Pon la lámpara de techo del cuarto infantil 1 en azul"
      ]
    },
    "Set the   to white": {
      "english": [
        "Set storage room light to white",
        "Set kid room 2 bedside lamp to orange",
        "Set kid room 3 sconce to pink",
        "Set bathroom 1 light to lavender",
        "Set lounge counter light to red"
      ],
      "dutch": [
        "Zet berginglicht op wit",
        "Zet het nachtlampje in kinderkamer 2 op oranje",
        "Zet de wandlamp in kinderkamer 3 op roze",
        "Zet het badkamerlicht 1 op lavendel",
        "Zet de counterlamp in de lounge op rood"
      ],
      "french": [
        "Règle la lampe du débarras sur blanc",
        "Règle la lampe de chevet de la chambre d’enfant 2 sur orange",
        "Règle l’applique murale de la chambre d’enfant 3 sur rose",
        "Règle la lampe de la salle de bain 1 sur lavande",
        "Règle la lumière du comptoir du salon sur rouge"
      ],
      "german": [
        "Stelle die Lampe im Abstellraum auf Weiß",
        "Stelle die Nachttischlampe im Kinderzimmer 2 auf Orange",
        "Stelle die Wandleuchte im Kinderzimmer 3 auf Rosa",
        "Stelle das Licht im Badezimmer 1 auf Lavendel",
        "Stelle die Thekenleuchte im Wohnzimmer auf Rot."
      ],
      "italian": [
        "Cambia la lampada da terra della camera da letto 1 in bianco freddo",
        "Imposta la lampada da comodino della cameretta 2 su arancione",
        "Imposta l’applique della cameretta 3 su rosa",
        "Imposta la luce del bagno 1 su lavanda",
        "Imposta la luce del bancone del soggiorno su rosso"
      ],
      "spanish": [
        "Cambia la lámpara de pie del dormitorio 1 a blanco frío",
        "Configura la lámpara de noche del cuarto infantil 2 en naranja",
        "Configura el aplique del cuarto infantil 3 en rosa",
        "Configura la luz del baño 1 en lavanda",
        "Configura la luz del mostrador del salón en rojo"
      ]
    },
    "Change the  to cool white": {
      "english": [
        "Change bedroom 1 floor lamp to cool white",
        "Change the hall chandelier to yellow",
        "Change the hallway wall light to teal",
        "Change the bathroom 2 wall light to purple"
      ],
      "dutch": [
        "Zet de vloerlamp in slaapkamer 1 op koel wit",
        "Zet de kroonluchter in de hal op geel",
        "Zet de wandlamp in de gang op blauwgroen",
        "Zet de wandlamp in badkamer 2 op paars"
      ],
      "french": [
        "Change la lampe sur pied de la chambre 1 en blanc froid",
        "Change le lustre du hall en jaune",
        "Change l’applique murale du couloir en turquoise",
        "Change l’applique murale de la salle de bain 2 en violet"
      ],
      "german": [
        "Stelle die Stehlampe im Schlafzimmer 1 auf Kaltweiß",
        "Stelle den Kronleuchter im Flur auf Gelb",
        "Stelle die Wandleuchte im Flur auf Blaugrün",
        "Stelle die Wandleuchte im Badezimmer 2 auf Lila."
      ],
      "italian": [
        "Metti la lampada a sospensione della camera da letto 2 su luce diurna",
        "Imposta il lampadario dell’ingresso su giallo",
        "Imposta l’applique del corridoio su turchese",
        "Imposta l’applique del bagno 2 su viola"
      ],
      "spanish": [
        "Pon la lámpara colgante del dormitorio 2 en luz de día",
        "Configura la lámpara de araña del pasillo en amarillo",
        "Configura la lámpara de pared del pasillo en turquesa",
        "Configura la lámpara de pared del baño 2 en morado"
      ]
    },
    "Make the  to daylight": {
      "english": [
        "Make bedroom 2 pendant light to daylight",
        "Make garden light to green",
        "Make the hallway ceiling light to cyan",
        "Make the main bedroom headboard light to magenta"
      ],
      "dutch": [
        "Zet de hanglamp in slaapkamer 2 op daglicht",
        "Zet de tuinlamp op groen",
        "Zet de plafondlamp in de gang op cyaan",
        "Zet de hoofdbordlamp in de hoofdslaapkamer op magenta"
      ],
      "french": [
        "Mets la suspension de la chambre 2 en lumière du jour",
        "Mets la lampe de jardin en vert",
        "Mets le plafonnier du couloir en cyan",
        "Mets la lampe de tête de lit de la chambre principale en magenta"
      ],
      "german": [
        "Stelle die Hängeleuchte im Schlafzimmer 2 auf Tageslichtweiß",
        "Stelle die Gartenlampe auf Grün",
        "Stelle die Deckenleuchte im Flur auf Cyanblau",
        "Stelle die Kopfteil‑Leuchte im Hauptschlafzimmer auf Magenta"
      ],
      "italian": [
        "Imposta la lampada da comodino della cameretta 2 su arancione",
        "Imposta la lampada da giardino su verde",
        "Imposta la plafoniera del corridoio su ciano",
        "Imposta la luce della testata del letto nella camera matrimoniale su magenta"
      ],
      "spanish": [
        "Configura la lámpara colgante del dormitorio 2 en luz diurna.",
        "Configura la lámpara del jardín en verde",
        "Configura la lámpara de techo del pasillo en cian",
        "Configura la luz del cabecero en el dormitorio principal en magenta"
      ]
    },
    "Set the   to red": {
      "english": [
        "Set the Hallway desk lamp to red"
      ],
      "dutch": [
        "Zet de bureaulamp in de gang op rood."
      ],
      "french": [
        "Réglez la lampe de bureau du couloir sur la couleur rouge"
      ],
      "german": [
        "Stelle die Schreibtischlampe im Flur auf Rot ein."
      ],
      "italian": [
        "Imposta la Luce da scrivania del corridoio sul rosso."
      ],
      "spanish": [
        "Pon la lámpara de escritorio del pasillo en rojo."
      ]
    },
    "Change the  to blue": {
      "english": [
        "Change the storage room 6 floor lamp 6 to blue"
      ],
      "dutch": [
        "Verander vloerlamp 6 in berging 6 naar blauw."
      ],
      "french": [
        "Changez le lampadaire 6 du débarras 6 en bleu"
      ],
      "german": [
        "Ändere die Stehleuchte 6 im Abstellraum 6 auf Blau."
      ],
      "italian": [
        "Cambia il colore della Luce da terra 6 nel ripostiglio 6 in blu."
      ],
      "spanish": [
        "Cambie la lámpara de pie número 6 del trastero número 6 a color azul."
      ]
    },
    "Switch the  to cool white": {
      "english": [
        "Switch the chandelier 1 to cool white"
      ],
      "dutch": [
        "Zet kroonluchter 1 op koel wit."
      ],
      "french": [
        "Réglez le lustre 1 sur blanc froid"
      ],
      "german": [
        "Schalten Sie den Chandelier 1 auf Kaltweiß."
      ],
      "italian": [
        "Imposta il lampadario 1 su bianco freddo."
      ],
      "spanish": [
        "Cambia la lámpara de araña 1 a blanco frío."
      ]
    }
  },
  "Switch/Plug/Socket/Outlet control": {
    "Turn on switch": {
      "english": [
        "Turn on accent light switch"
      ],
      "dutch": [
        "Zet de accentlichtschakelaar aan"
      ],
      "french": [
        "Mets en marche l’interrupteur de la lumière d’accentuation"
      ],
      "german": [
        "Schalte das Akzentlicht ein"
      ],
      "italian": [
        "Accendi l’interruttore della luce d’accento"
      ],
      "spanish": [
        "Enciende el interruptor de la luz de acento"
      ]
    },
    "Turn off switch": {
      "english": [
        "Turn off desk lamp switch"
      ],
      "dutch": [
        "Zet de bureaulampschakelaar uit"
      ],
      "french": [
        "Éteins l’interrupteur de la lampe de bureau"
      ],
      "german": [
        "Schalte die Schreibtischlampe aus"
      ],
      "italian": [
        "Spegni l’interruttore della lampada da scrivania"
      ],
      "spanish": [
        "Apaga el interruptor de la lámpara de escritorio"
      ]
    },
    "Turn on plug": {
      "english": [
        "Turn on kettle plug"
      ],
      "dutch": [
        "Zet de waterkokerstekker aan"
      ],
      "french": [
        "Mets en marche la prise de la bouilloire"
      ],
      "german": [
        "Schalte den Wasserkocher ein"
      ],
      "italian": [
        "Accendi la presa del bollitore"
      ],
      "spanish": [
        "Enciende el enchufe del hervidor"
      ]
    },
    "Turn off plug": {
      "english": [
        "Turn off water boiler plug"
      ],
      "dutch": [
        "Zet de waterkokerschakelaar uit"
      ],
      "french": [
        "Éteins la prise du chauffe‑eau"
      ],
      "german": [
        "Schalte den Wasserkocher aus"
      ],
      "italian": [
        "Spegni la presa del boiler"
      ],
      "spanish": [
        "Apaga el enchufe del calentador de agua"
      ]
    },
    "Turn on socket": {
      "english": [
        "Turn on TV socket"
      ],
      "dutch": [
        "Zet het tv‑stopcontact aan"
      ],
      "french": [
        "Mets en marche la prise télé"
      ],
      "german": [
        "Schalte die TV‑Steckdose ein"
      ],
      "italian": [
        "Accendi la presa della TV"
      ],
      "spanish": [
        "Enciende el enchufe de la TV"
      ]
    },
    "Turn off socket": {
      "english": [
        "Turn off TV socket"
      ],
      "dutch": [
        "Zet het tv‑stopcontact uit"
      ],
      "french": [
        "Éteins la prise télé"
      ],
      "german": [
        "Schalte die TV‑Steckdose aus"
      ],
      "italian": [
        "Spegni la presa della TV"
      ],
      "spanish": [
        "«Apaga el enchufe de la TV"
      ]
    },
    "Turn on": {
      "english": [
        "Turn on charging socket",
        "Turn on coffee maker socket"
      ],
      "dutch": [
        "Zet het oplaadstopcontact aan",
        "Zet het stopcontact van het koffiezetapparaat aan"
      ],
      "french": [
        "Mets en marche la prise de charge",
        "Mets en marche la prise de la cafetière"
      ],
      "german": [
        "Schalte die Ladesteckdose ein",
        "Schalte die Steckdose der Kaffeemaschine ein"
      ],
      "italian": [
        "Accendi la presa di ricarica",
        "Accendi la presa della macchina del caffè"
      ],
      "spanish": [
        "Enciende el enchufe de carga",
        "Enciende la toma de la cafetera"
      ]
    },
    "Turn off": {
      "english": [
        "Turn off computer outlet",
        "Turn off cooker outlet"
      ],
      "dutch": [
        "Zet het computerstopcontact uit",
        "Zet het stopcontact van het fornuis uit"
      ],
      "french": [
        "Éteins la prise de l’ordinateur",
        "Éteins la prise de la cuisinière"
      ],
      "german": [
        "Schalte die Computersteckdose aus",
        "Schalte die Herdsteckdose aus"
      ],
      "italian": [
        "Spegni la presa del computer",
        "Spegni la presa del fornello"
      ],
      "spanish": [
        "Apaga el enchufe del ordenador",
        "Apaga la toma del horno"
      ]
    },
    "Activate": {
      "english": [
        "Activate Coffee maker outlet 4 in livingroom"
      ],
      "dutch": [
        "Zet stopcontact 4  aan voor het koffiezetapparaat in de woonkamer."
      ],
      "french": [
        "Activer la prise de cafetière 4 dans le salon"
      ],
      "german": [
        "Steckdose 4 für die Kaffeemaschine im Wohnzimmer aktivieren"
      ],
      "italian": [
        "Attiva la presa n. 4 per la macchina del caffè nel soggiorno."
      ],
      "spanish": [
        "Activar la toma de corriente 4 de la cafetera en la sala de estar."
      ]
    },
    "Switch on": {
      "english": [
        "Switch on Cooker outlet 2"
      ],
      "dutch": [
        "Schakel fornuisstopcontact 2 aan."
      ],
      "french": [
        "Allumer la prise de cuisinière 2"
      ],
      "german": [
        "Herdanschlussdose 2 einschalten"
      ],
      "italian": [
        "Accensione Presa fornello 2"
      ],
      "spanish": [
        "Encienda la toma de corriente n.º 2.de la cocina"
      ]
    },
    "Power off socket": {
      "english": [
        "Power off Socket in Attic"
      ],
      "dutch": [
        "Stopcontact op zolder uitschakelen"
      ],
      "french": [
        "Éteindre la prise du grenier"
      ],
      "german": [
        "Steckdose auf dem Dachboden stromlos schalten"
      ],
      "italian": [
        "Disattivare la presa in soffitta"
      ],
      "spanish": [
        "Desconectar el enchufe del ático"
      ]
    },
    "Switch off socket": {
      "english": [
        "switch off outlet 3"
      ],
      "dutch": [
        "Schakel stopcontact 3 uit."
      ],
      "french": [
        "Éteindre la prise 3"
      ],
      "german": [
        "Steckdose 3 ausschalten"
      ],
      "italian": [
        "Spegni la presa 3"
      ],
      "spanish": [
        "Apagar la toma de corriente 3"
      ]
    }
  },
  "Thermostat Temperature control": {
    "Increase temperature": {
      "english": [
        "Increase temperature on hall thermostat"
      ],
      "dutch": [
        "Verhoog de temperatuur op de thermostaat in de hal"
      ],
      "french": [
        "Augmenter la température du thermostat du couloir"
      ],
      "german": [
        "Temperatur am Flurthermostat erhöhen"
      ],
      "italian": [
        "Aumentare la temperatura del termostato del corridoio"
      ],
      "spanish": [
        "Subir la temperatura del termostato del pasillo"
      ]
    },
    "Decrease temperature": {
      "english": [
        "Decrease temperature on hallway thermostat"
      ],
      "dutch": [
        "Verlaag de temperatuur op de thermostaat in de hal"
      ],
      "french": [
        "Diminuer la température du thermostat du couloir"
      ],
      "german": [
        "Temperatur am Flurthermostat senken"
      ],
      "italian": [
        "Diminuire la temperatura del termostato del corridoio"
      ],
      "spanish": [
        "Bajar la temperatura del termostato del pasillo"
      ]
    },
    "Set to cool mode": {
      "english": [
        "set dining room thermostat to cool mode"
      ],
      "dutch": [
        "Zet de thermostaat in de eetkamer op koelen"
      ],
      "french": [
        "Régler le thermostat de la salle à manger en mode refroidissement"
      ],
      "german": [
        "Thermostat im Esszimmer auf Kühlmodus stellen"
      ],
      "italian": [
        "Impostare il termostato della sala da pranzo in modalità raffreddamento"
      ],
      "spanish": [
        "Configurar el termostato del comedor en modo frío"
      ]
    },
    "Set to heat mode": {
      "english": [
        "set garage thermostat to heat mode"
      ],
      "dutch": [
        "Zet de thermostaat in de garage op verwarmen"
      ],
      "french": [
        "Régler le thermostat du garage en mode chauffage"
      ],
      "german": [
        "Thermostat in der Garage auf Heizmodus stellen"
      ],
      "italian": [
        "Impostare il termostato del garage in modalità riscaldamento"
      ],
      "spanish": [
        "Configurar el termostato del garaje en modo calor"
      ]
    },
    "Turn up": {
      "english": [
        "Turn up the bedroom 3 thermostat"
      ],
      "dutch": [
        "Zet de thermostaat van slaapkamer 3 hoger."
      ],
      "french": [
        "Augmentez le thermostat de la chambre 3"
      ],
      "german": [
        "Dreh das Thermostat im Schlafzimmer 3 höher."
      ],
      "italian": [
        "Alza il termostato della camera da letto 3."
      ],
      "spanish": [
        "Sube el termostato del dormitorio 3."
      ]
    },
    "Turn down": {
      "english": [
        "Turn down storage room thermostat temperature"
      ],
      "dutch": [
        "Verlaag de temperatuur van de thermostaat in de berging."
      ],
      "french": [
        "Baissez la température du thermostat du débarras"
      ],
      "german": [
        "Temperatur am Thermostat des Abstellraum senken"
      ],
      "italian": [
        "Abbassa la temperatura del termostato del ripostiglio."
      ],
      "spanish": [
        "Baja la temperatura del termostato del trastero."
      ]
    },
    "Raise": {
      "english": [
        "Raise the thermostat temperature",
        "Raise the kitchen thermostat to 26°C."
      ],
      "dutch": [
        "Zet de thermostaat hoger",
        "Zet de thermostaat in de keuken hoger, op 26°C."
      ],
      "french": [
        "Augmentez la température du thermostat",
        "Augmentez le thermostat de la cuisine à 26 °C"
      ],
      "german": [
        "Erhöhen Sie die Temperatur am Thermostat.",
        "Stelle das Küchenthermostat auf 26 Grad"
      ],
      "italian": [
        "Alza la temperatura del termostato.",
        "Alza il termostato della cucina a 26°C."
      ],
      "spanish": [
        "Sube la temperatura del termostato.",
        "Sube el termostato de la cocina a 26 °C."
      ]
    },
    "Switch to cool mode": {
      "english": [
        "Switch Laundryroom thermostat to cool mode"
      ],
      "dutch": [
        "Zet de thermostaat in de wasruimte op de koelstand."
      ],
      "french": [
        "Réglez le thermostat de la buanderie sur le mode refroidissement"
      ],
      "german": [
        "Thermostat in der Waschküche auf Kühlmodus stellen"
      ],
      "italian": [
        "Imposta il termostato della lavanderia sulla modalità di raffreddamento."
      ],
      "spanish": [
        "Cambie el termostato del cuarto de lavado al modo de refrigeración."
      ]
    },
    "Switch to warm mode": {
      "english": [
        "Switch bathroom 2 thermostat to warm mode"
      ],
      "dutch": [
        "Zet de thermostaat van badkamer 2 op de verwarmingsstand."
      ],
      "french": [
        "Réglez le thermostat de la salle de bain 2 sur le mode chauffage"
      ],
      "german": [
        "Thermostat im Badezimmer 2 auf Heizmodus stellen"
      ],
      "italian": [
        "Imposta il termostato del secondo bagno sulla modalità riscaldamento."
      ],
      "spanish": [
        "Cambia el termostato del baño 2 al modo de calefacción."
      ]
    },
    "Reduce": {
      "english": [
        "Reduce the Bedroom eight thermostat temperature to 7°C"
      ],
      "dutch": [
        "Verlaag de temperatuur van de thermostaat in slaapkamer 8 naar 7 °C."
      ],
      "french": [
        "Réduisez la température du thermostat de la chambre 8 à 7 °C"
      ],
      "german": [
        "Senke die Temperatur des Thermostats in Schlafzimmer 8 auf 7 Grad"
      ],
      "italian": [
        "Imposta la temperatura del termostato della Camera da letto 8 a 7°C."
      ],
      "spanish": [
        "Reduce la temperatura del termostato del dormitorio 8 a 7 °C."
      ]
    },
    "Set": {
      "english": [
        "Set thermostat to warm in attic"
      ],
      "dutch": [
        "Stel de thermostaat in de zolder in op warm"
      ],
      "french": [
        "Régler le thermostat du grenier sur chaud"
      ],
      "german": [
        "Stelle das Thermostat im Dachboden auf warm"
      ],
      "italian": [
        "Imposta il termostato della soffitta su caldo"
      ],
      "spanish": [
        "Ajusta el termostato del ático a cálido"
      ]
    },
    "What is the current room temperature": {
      "english": [
        "What is the current room temperature"
      ],
      "dutch": [
        "Wat is de huidige kamertemperatuur?"
      ],
      "french": [
        "Quelle est la température actuelle de la pièce ?"
      ],
      "german": [
        "Wie hoch ist die aktuelle Raumtemperatur?"
      ],
      "italian": [
        "Qual è la temperatura ambiente attuale?"
      ],
      "spanish": [
        "¿Cuál es la temperatura actual de la habitación?"
      ]
    },
    "What is the ambient temperature": {
      "english": [
        "What is the ambient temperature"
      ],
      "dutch": [
        "Wat is de omgevingstemperatuur"
      ],
      "french": [
        "Quelle est la température ambiante ?"
      ],
      "german": [
        "Wie hoch ist die Aussentemperatur?"
      ],
      "italian": [
        "Qual è la temperatura ambiente?"
      ],
      "spanish": [
        "¿Cuál es la temperatura ambiente?"
      ]
    }
  },
  "Fan Control": {
    "Set to low speed": {
      "english": [
        "set home office desk fan to low speed"
      ],
      "dutch": [
        "Zet de bureauventilator in het thuiskantoor op de lage stand"
      ],
      "french": [
        "Règle le ventilateur du bureau à domicile sur la vitesse basse"
      ],
      "german": [
        "Stelle den Tischventilator im Homeoffice auf niedrige Stufe."
      ],
      "italian": [
        "Imposta la ventola della scrivania dell'ufficio a bassa velocità"
      ],
      "spanish": [
        "Ajustar el ventilador del escritorio de la oficina a baja velocidad"
      ]
    },
    "Set to medium speed": {
      "english": [
        "set kitchen exhaust fan to medium speed"
      ],
      "dutch": [
        "Zet de afzuigkap in de keuken op de middelste stand"
      ],
      "french": [
        "Règle la hotte de la cuisine sur la vitesse moyenne"
      ],
      "german": [
        "Stelle die Küchenabzugshaube auf mittlere Stufe."
      ],
      "italian": [
        "Imposta la ventola di scarico della cucina a media velocità"
      ],
      "spanish": [
        "Ajustar el extractor de aire de la cocina a velocidad media"
      ]
    },
    "Set to high speed": {
      "english": [
        "set kid room bedside fan to high speed"
      ],
      "dutch": [
        "Zet de ventilator naast het bed in de kinderkamer op de hoge stand"
      ],
      "french": [
        "Règle le ventilateur de la chambre d'enfant sur la vitesse haute"
      ],
      "german": [
        "Stelle den Ventilator im Kinderzimmer auf hohe Stufe."
      ],
      "italian": [
        "Imposta il ventilatore da comodino della cameretta dei bambini ad alta velocità"
      ],
      "spanish": [
        "Ajustar el ventilador de la mesita de noche de la habitación de los niños a alta velocidad"
      ]
    },
    "Set to auto": {
      "english": [
        "set family room sofa fan to auto"
      ],
      "dutch": [
        "Zet de ventilator bij de bank in de woonkamer op automatisch"
      ],
      "french": [
        "Mets le ventilateur du canapé de la salle familiale en mode automatique"
      ],
      "german": [
        "Stelle den Sofaventilator im Wohnzimmer auf Automatik."
      ],
      "italian": [
        "Imposta il ventilatore del divano del soggiorno su automatico"
      ],
      "spanish": [
        "Ajustar el ventilador del sofá de la sala a automático"
      ]
    },
    "Set to off": {
      "english": [
        "set family room ceiling fan to off"
      ],
      "dutch": [
        "Zet de plafondventilator in de familiekamer uit."
      ],
      "french": [
        "Éteins le ventilateur de plafond de la salle familiale"
      ],
      "german": [
        "Schalte den Deckenventilator im Familienzimmer aus"
      ],
      "italian": [
        "Imposta il ventilatore a soffitto della sala di famiglia su spento"
      ],
      "spanish": [
        "Ajustar el ventilador de techo de la sala familiar en apagado"
      ]
    },
    "Turn on fan": {
      "english": [
        "Turn on laundry room wall fan"
      ],
      "dutch": [
        "Zet de wandventilator in de wasruimte aan"
      ],
      "french": [
        "Mets en marche le ventilateur mural de la buanderie"
      ],
      "german": [
        "Schalte den Wandventilator in der Waschküche ein"
      ],
      "italian": [
        "Accendi il ventilatore a parete della lavanderia"
      ],
      "spanish": [
        "Enciende el ventilador de pared de la lavandería"
      ]
    },
    "Turn off fan": {
      "english": [
        "Turn off study room table fan"
      ],
      "dutch": [
        "Zet de tafelventilator in de studeerkamer uit"
      ],
      "french": [
        "Éteins le ventilateur de table dans le bureau"
      ],
      "german": [
        "Schalte den Tischventilator im Arbeitszimmer aus"
      ],
      "italian": [
        "Spegni il ventilatore da tavolo nella sala di studio"
      ],
      "spanish": [
        "Apaga el ventilador de mesa del estudio"
      ]
    },
    "Switch on": {
      "english": [
        "Switch on the Ceiling fan in mainbedroom"
      ],
      "dutch": [
        "Zet de plafondventilator in de hoofdslaapkamer aan."
      ],
      "french": [
        "Allumez le ventilateur de plafond de la chambre principale."
      ],
      "german": [
        "Schalte den Deckenventilator im Hauptschlafzimmer ein."
      ],
      "italian": [
        "Accendi il ventilatore a soffitto nella camera da letto principale."
      ],
      "spanish": [
        "Encender el ventilador de techo en el dormitorio principal"
      ]
    },
    "Power on": {
      "english": [
        "Power on Bedroom 1 Exhaust fan 4"
      ],
      "dutch": [
        "Schakel afzuigventilator 4 in slaapkamer 1 aan"
      ],
      "french": [
        "Mettre en marche le ventilateur d'extraction 4 de la chambre 1"
      ],
      "german": [
        "Abluftventilator 4 in Schlafzimmer 1 einschalten"
      ],
      "italian": [
        "Accendi la ventola di scarico 4 della camera da letto 1."
      ],
      "spanish": [
        "Encender el extractor 4 del dormitorio 1."
      ]
    },
    "Increase": {
      "english": [
        "Increase the exhaust fan 6 to high speed"
      ],
      "dutch": [
        "Zet bureauventilator 6 op de hoogste stand."
      ],
      "french": [
        "Réglez le ventilateur d'extraction 6 sur la vitesse élevée."
      ],
      "german": [
        "Erhöhe die Geschwindigkeit des Abluftventilators 6 auf die hohe Stufe."
      ],
      "italian": [
        "Portare la ventola di scarico 6 alla massima velocità."
      ],
      "spanish": [
        "Aumenta la velocidad del sexto ventilador de extracción a la posición alta."
      ]
    },
    "Put": {
      "english": [
        "Put the desk fan in Bathroom 10 on auto mode"
      ],
      "dutch": [
        "Zet de bureauventilator in badkamer 10 op de automatische stand."
      ],
      "french": [
        "Mettez le ventilateur de bureau de la salle de bains 10 en mode automatique."
      ],
      "german": [
        "Stelle den Tischventilator in Badezimmer 10 auf den Automatikmodus."
      ],
      "italian": [
        "Imposta il ventilatore da scrivania nel bagno 10 sulla modalità automatica."
      ],
      "spanish": [
        "Pon el ventilador de escritorio del baño 10 en modo automático."
      ]
    },
    "Keep": {
      "english": [
        "Keep the table fan in Bedroom nine at medium speed"
      ],
      "dutch": [
        "Zet de tafelventilator in slaapkamer 9 op de middelste stand."
      ],
      "french": [
        "Maintenez le ventilateur de table de la chambre 9 à vitesse moyenne."
      ],
      "german": [
        "Lasse den Tischventilator im Schlafzimmer 9 auf mittlerer Stufe laufen."
      ],
      "italian": [
        "Mantieni il ventilatore da tavolo nella camera da letto numero nove a velocità media."
      ],
      "spanish": [
        "Mantén el ventilador de mesa del dormitorio nueve a velocidad media."
      ]
    },
    "Lower": {
      "english": [
        "Lower the table fan to low speed"
      ],
      "dutch": [
        "Zet de tafelventilator op de lage stand."
      ],
      "french": [
        "Réglez le ventilateur de table sur la vitesse basse"
      ],
      "german": [
        "Stelle den Tischventilator auf die niedrige Stufe."
      ],
      "italian": [
        "Imposta il ventilatore da tavolo alla velocità minima."
      ],
      "spanish": [
        "Baja la velocidad del ventilador de mesa a la posición baja."
      ]
    }
  },
  "Air Purifier control": {
    "Turn on": {
      "english": [
        "Turn on pet area purifier"
      ],
      "dutch": [
        "Zet de luchtreiniger in de dierenhoek aan"
      ],
      "french": [
        "Mets en marche le purificateur du coin des animaux"
      ],
      "german": [
        "Schalte den Luftreiniger im Tierbereich ein"
      ],
      "italian": [
        "Accendi il purificatore dell’area animali"
      ],
      "spanish": [
        "Enciende el purificador del área de mascotas"
      ]
    },
    "Turn off": {
      "english": [
        "Turn off hall purifier"
      ],
      "dutch": [
        "Zet de luchtreiniger in de woonkamer uit"
      ],
      "french": [
        "Éteins le purificateur du couloir"
      ],
      "german": [
        "Schalte den Luftreiniger im Flur aus"
      ],
      "italian": [
        "Spegni il purificatore del corridoio"
      ],
      "spanish": [
        "Apaga el purificador del pasillo"
      ]
    },
    "Set to auto": {
      "english": [
        "Set Main bedroom purifier to auto"
      ],
      "dutch": [
        "Zet de luchtreiniger in de hoofdslaapkamer op automatisch"
      ],
      "french": [
        "Mets le purificateur de la chambre principale en mode automatique"
      ],
      "german": [
        "Stelle den Luftreiniger im Hauptschlafzimmer auf Automatik"
      ],
      "italian": [
        "Imposta il purificatore della camera principale su automatico"
      ],
      "spanish": [
        "Configura el purificador del dormitorio principal en automático"
      ]
    },
    "Decrease temperature": {
      "english": [
        "Decrease temperature on Study room purifier"
      ],
      "dutch": [
        "Verlaag de temperatuur van de luchtreiniger in de studeerkamer"
      ],
      "french": [
        "Diminue la température du purificateur de la salle d’étude"
      ],
      "german": [
        "Senke die Temperatur des Luftreinigers im Arbeitszimmer"
      ],
      "italian": [
        "Diminuisci la temperatura del purificatore nello studio"
      ],
      "spanish": [
        "Baja la temperatura del purificador del estudio"
      ]
    },
    "Power off": {
      "english": [
        "Power off the desk purifier"
      ],
      "dutch": [
        "Schakel de luchtreiniger op het bureau uit."
      ],
      "french": [
        "Éteignez le purificateur d'air de bureau"
      ],
      "german": [
        "Schalte den Schreibtischreiniger aus."
      ],
      "italian": [
        "Spegni il purificatore da scrivania."
      ],
      "spanish": [
        "Apague el purificador de escritorio."
      ]
    },
    "Power on": {
      "english": [
        "Power on the Hall purifier"
      ],
      "dutch": [
        "Schakel de luchreiniger in de woonkamer aan."
      ],
      "french": [
        "Mettre le purificateur du couloir sous tension"
      ],
      "german": [
        "Schalte den Flur-Reiniger ein."
      ],
      "italian": [
        "Accendi il purificatore della Hall."
      ],
      "spanish": [
        "Encienda el purificador Hall."
      ]
    },
    "Turn up": {
      "english": [
        "Turn up the temperature on the Bedside purifier"
      ],
      "dutch": [
        "Verhoog de temperatuur van de luchtreiniger naast het bed."
      ],
      "french": [
        "Augmentez la température du purificateur d'air de chevet"
      ],
      "german": [
        "Erhöhe die Temperatur am Nachtreiniger."
      ],
      "italian": [
        "Aumenta la temperatura del purificatore da comodino."
      ],
      "spanish": [
        "Sube la temperatura del purificador de mesita de noche."
      ]
    },
    "Decrease": {
      "english": [
        "Decrease the heat level on the Air purifier"
      ],
      "dutch": [
        "Verlaag de warmtestand van de luchtreiniger."
      ],
      "french": [
        "Réduisez le niveau de chauffe du purificateur d'air"
      ],
      "german": [
        "Verringere die Heizstufe des Luftreinigers."
      ],
      "italian": [
        "Abbassa il livello di calore del purificatore d'aria."
      ],
      "spanish": [
        "Reduce el nivel de calor del purificador de aire."
      ]
    }
  },
  "Blinds, Curtain, shades control": {
    "Blinds": {
      "english": [
        "Open blind 1 by 35%"
      ],
      "dutch": [
        "Open jaloezieën 1 voor 35%"
      ],
      "french": [
        "Ouvrir le store 1 de 35 %"
      ],
      "german": [
        "Jalousie 1 zu 35 % öffnen"
      ],
      "italian": [
        "Apri la tenda 1 del 35%"
      ],
      "spanish": [
        "Ciego abierto 1 por 35%"
      ]
    },
    "Curtain": {
      "english": [
        "Close blind 2 in Bedroom 2 by 55%"
      ],
      "dutch": [
        "Sluit jaloezieën 2 in slaapkamer 2 voor 55%"
      ],
      "french": [
        "Fermer le store 2 de la chambre 2 à 55 %"
      ],
      "german": [
        "Schließe Jalousie 2 in Schlafzimmer 2 um 55 %."
      ],
      "italian": [
        "Chiudi la tenda 2 nella Camera da letto 2 del 55%"
      ],
      "spanish": [
        "Cierra la persiana 2 del dormitorio 2 un 55 %."
      ]
    },
    "Roller Shades": {
      "english": [
        "Close curtain 3 in theatre by 10%"
      ],
      "dutch": [
        "Sluit theatergordijn 3 voor 10%"
      ],
      "french": [
        "Fermer le rideau 3 de la salle de home cinéma de 10 %"
      ],
      "german": [
        "Vorhang 3 im Theater um 10 % schließen"
      ],
      "italian": [
        "Chiudere la tenda 3 del teatro del 10%"
      ],
      "spanish": [
        "Cerrar la cortina 3 del teatro un 10 %."
      ]
    },
    "Open blinds": {
      "english": [
        "open main bedroom blinds"
      ],
      "dutch": [
        "Open de jaloezieën in de hoofdslaapkamer"
      ],
      "french": [
        "Ouvrir les stores de la chambre principale"
      ],
      "german": [
        "Öffne die Jalousien im Hauptschlafzimmer."
      ],
      "italian": [
        "Apri le tende della camera da letto principale"
      ],
      "spanish": [
        "Abrir las persianas del dormitorio principal"
      ]
    },
    "Close blinds": {
      "english": [
        "close bedroom 3 blinds"
      ],
      "dutch": [
        "Sluit de jaloezieën  in slaapkamer 3"
      ],
      "french": [
        "Fermer les stores de la chambre 3"
      ],
      "german": [
        "Schließe die Vorhänge in Schlafzimmer 3."
      ],
      "italian": [
        "Chiudi le tende della camera da letto 3"
      ],
      "spanish": [
        "Cerrar las cortinas del dormitorio 3"
      ]
    },
    "Stop blinds": {
      "english": [
        "stop bedroom 3 blinds"
      ],
      "dutch": [
        "Stop de jaloezieën in slaapkamer 3"
      ],
      "french": [
        "Arrêter les stores de la chambre 3"
      ],
      "german": [
        "Stoppe die Vorhänge in Schlafzimmer 3."
      ],
      "italian": [
        "Ferma le tende della camera da letto 3"
      ],
      "spanish": [
        "Detener las cortinas del dormitorio 3"
      ]
    },
    "Lower shades": {
      "english": [
        "Lower family room shades"
      ],
      "dutch": [
        "Laat de jaloezieën in de familiekamer zakken"
      ],
      "french": [
        "Baisser les stores de la salle familiale"
      ],
      "german": [
        "Senke die Jalousien im Familienzimmer"
      ],
      "italian": [
        "Abbassa a tende del soggiorno"
      ],
      "spanish": [
        "Bajar las persianas de la sala familiar"
      ]
    },
    "Raise curtain": {
      "english": [
        "raise dinning room curtain"
      ],
      "dutch": [
        "Trek de jaloezieën in de eetkamer omhoog"
      ],
      "french": [
        "Ouvir le rideau de la salle à manger"
      ],
      "german": [
        "Hebe den Vorhang im Esszimmer"
      ],
      "italian": [
        "Alza a tenda della sala da pranzo"
      ],
      "spanish": [
        "Subir la cortina del comedor"
      ]
    },
    "Raise": {
      "english": [
        "Raise the garage blinds",
        "Raise the Dining room curtain 2"
      ],
      "dutch": [
        "Doe de garagerollluiken omhoog.",
        "Doe gordijn 2 in de eetkamer omhoog"
      ],
      "french": [
        "Relevez les stores du garage.",
        "Levez le rideau 2 de la salle à manger."
      ],
      "german": [
        "Ziehe die Garagenrollläden hoch.",
        "Ziehe den Vorhang 2 im Esszimmer hoch"
      ],
      "italian": [
        "Alza le serrande del garage.",
        "Solleva la tenda della sala da pranzo 2"
      ],
      "spanish": [
        "Sube las persianas del garaje.",
        "Levanta la cortina 2, del comedor"
      ]
    },
    "Roll down": {
      "english": [
        "Roll down the living room blinds"
      ],
      "dutch": [
        "Zak de jaloezieën in de woonkamer."
      ],
      "french": [
        "Baissez les stores du salon."
      ],
      "german": [
        "Lass die Jalousien im Wohnzimmer herunter."
      ],
      "italian": [
        "Abbassa le tapparelle del soggiorno."
      ],
      "spanish": [
        "Baja las persianas de la sala de estar."
      ]
    },
    "Move": {
      "english": [
        "Move the Family room  2 shades 3 downward"
      ],
      "dutch": [
        "Zet de zonwering in woonkamer2, drie standen naar beneden."
      ],
      "french": [
        "Abaissez le store 3 du salon 2"
      ],
      "german": [
        "Schiebe Jalousien 3 im Familienzimmer um 3 Stufen nach unten."
      ],
      "italian": [
        "Sposta la Family Room di 3 posizioni verso il basso."
      ],
      "spanish": [
        "Baja las persianas de la sala de estar tres niveles."
      ]
    },
    "Lift": {
      "english": [
        "Lift the blinds 4"
      ],
      "dutch": [
        "Trek jaloezieën 4 omhoog"
      ],
      "french": [
        "Relevez les stores 4"
      ],
      "german": [
        "Ziehe die Jalousie 4 hoch"
      ],
      "italian": [
        "Solleva le tende 4"
      ],
      "spanish": [
        "Levanta las persianas 4"
      ]
    }
  }
};

export {
  iotControlData,
  translations
};